/* eslint-disable camelcase */
/* eslint-disable no-use-before-define */
import React, {ReactElement, useEffect, useState} from 'react';
import {
  Button,
  Card,
  CardContent,
  Checkbox,
  createStyles,
  FormControl,
  FormControlLabel,
  FormHelperText,
  makeStyles,
  Radio,
  Theme,
  Typography
} from '@material-ui/core';
import {useTranslation, Trans} from 'react-i18next';

import './CardPaymentStyles.scss';
import BackNavigation from '../backNavigation/BackNavigation';
import {
  APP,
  APP_PRIMARY_COLOR,
  BLACK_COLOR,
  BORDER_COLOR,
  BORDER_PRIMARY_COLOR,
  DEFAULT_BLACK_COLOR,
  DEFAULT_RED_COLOR,
  DEFAULT_WHITE_COLOR,
  ENTER_CARD_BUTTON,
  GET_8_PIXEL_BOX,
  PAYMENTS_BACKGROUND_COLOR,
  SWIPE_BUTTON_COLOR
} from 'src/style/variable';
import NavRoutes from 'src/constants/route/NavRoutes';
import FormCurrencyField from '@components/system/FormInput/FormCurrencyField';
import './instamed-token';
import {Controller, useForm} from 'react-hook-form';
import {useSnackbar} from 'notistack';
import {SnackBarConfig} from '../../../utils/SnackBarConfig';
import {
  getDetailsFromAdmin,
  paymentPatientMiscChargeSaleService,
  paymentSaleService,
  adhocPaymentClinicSale,
  paymentPatientSaleService,
  publicPaymentPatientSaleService,
  getCardMachineReferenceId
} from '@shared/services/PaymentProvider.service';
import {connect, useDispatch, useSelector} from 'react-redux';
import {
  _guarantorPayAmount,
  _guarantorPaymentResult,
  _saveAmountsAndRequiredDataForPayment,
  _setPayInInstallmentDetails,
  _updatePaymentType,
  _guarantorPayCashAmount
} from '@shared/store/actions/PaymentActions';
import {_cardMachineReferenceId} from '@shared/store/actions/CardMachineActions';
import CurrencyFormatter from '@components/system/CurrencyFormatter/CurrencyFormatter';
import OpenEdge from './Providers/OpenEdge/OpenEdge';
import {
  AppPaymentStatus,
  PAYMENT_METHODS,
  PaymentTypes,
  GuarantorPortalPaymentTypes,
  // getChargeTypeLabel,
  paymentMethodTypes,
  MIN_INSTALMENTS,
  PAYMENT_PLAN_FREQUENCY_IDS,
  MAX_INSTALMENTS,
  SEARCH_DEBOUNCE_DELAY,
  CASH_PAYMENT
} from '@shared/constants/Mapping';
import HelperUtils, {
  checkIfNaturalNumber,
  getInstalmentDates,
  // groupByChargeType,
  sortByPriority
} from '@shared/utils/HelperUtils';
import {PAYMENT_CLINIC_DETAILS} from '@shared/store/actions/Index';
import Instamed from './Providers/Instamed/Instamed';
import Loader from '@components/framework/loader/Loader';
// import PaymentConfirmationDialog from 'src/modules/admin/modules/Common/PaymentConfirmationDialog';
import {ChargeTypeServiceMapper} from '@shared/services/service-mappers/PaymentServiceMapper';
import ConfirmationDetails from './ConfirmationDetails';
import DateTimePickerWrapper from '@components/system/CustomDateTimePicker/DateTimePickerWrapper';
import PayInInstallmentDetails from '../PayInInstallment/PayInInstallementDetails';
import {
  createPlanForGuarantor,
  createPlanFromGuarantorPortal,
  generatePaymentAmounts,
  generatePaymentPlanAmountGuarantorPortal
} from '@shared/services/Payment.service';
import CustomDropDown from '@components/system/CustomDropDown/CustomDropDown';
import {referenceDataService} from '@shared/services/ReferenceData.service';
import moment from 'moment';
import ButtonLoader from '@components/system/ButtonLoader/ButtonLoader';
import MachineCardComponent from './Providers/MachineCardComponent/MachineCardComponent';
import ReactLoader from './Providers/MachineCardComponent/ReactLoader';
import ErrorPage from './Providers/Errorpage';
import StyledOutlinedInput from '@components/system/FormInput/StyledOutlinedInput';
import RadioComponent from '@components/system/Radio/RadioComponent';
import {getClinicGroupsDetails} from '@shared/services/ClinicServices';
import {
  getGuarantorBalancesFromMultipleLocations,
  getGuarantorDueBalancesGuarantorPortal
} from '@shared/services/DueInvoiceServices';
import DueBalancesCard from './DueBalancesCard';
import {groupBy} from 'lodash';
import {useDebouncedCallback} from 'use-debounce';

const {innerWidth: width} = window;
const isDesktop = width >= 1024;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    loginButton: {
      padding: `${GET_8_PIXEL_BOX(1)} 0`,
      fontFamily: APP.FONT_FAMILY.BOLD,
      height: '2.7rem'
    },
    swipeCardButton: {
      padding: `${GET_8_PIXEL_BOX(1)} 0`,
      fontFamily: APP.FONT_FAMILY.BOLD,
      height: '2.7rem',
      backgroundColor: `${SWIPE_BUTTON_COLOR}`,
      color: `${DEFAULT_WHITE_COLOR}`,
      '&:hover': {
        backgroundColor: `${SWIPE_BUTTON_COLOR}`,
        color: `${DEFAULT_WHITE_COLOR}`
      }
    },
    enterCardButton: {
      backgroundColor: `${ENTER_CARD_BUTTON}`,
      padding: `${GET_8_PIXEL_BOX(1)} 0`,
      fontFamily: APP.FONT_FAMILY.BOLD,
      height: '2.7rem'
    },
    paymentDialogButtons: {
      display: 'flex',
      justifyContent: 'space-between'
    },
    card: {
      borderRadius: 0,
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.primary.contrastText,
      boxShadow: 'none'
    },
    cardPadding: {
      '& .MuiCardContent-root': {
        padding: 0
      },
      padding: 0
    },
    balanceSectionHeader: {
      fontSize: '1rem',
      color: BLACK_COLOR,
      fontWeight: 'bold',
      marginTop: '1rem'
    },
    fieldText: {
      display: 'flex',
      color: BLACK_COLOR,
      paddingBottom: '0.5rem',
      justifyContent: 'flex-start',
      fontSize: '1.2rem'
    },
    fieldTextAmount: {
      display: 'flex',
      color: BLACK_COLOR,
      paddingBottom: '0.5rem',
      justifyContent: 'flex-start',
      fontSize: '1.2rem',
      marginRight: '5px'
    },
    fieldValue: {
      display: 'flex',
      color: BLACK_COLOR,
      paddingBottom: '0.5rem',
      justifyContent: 'flex-start',
      fontWeight: 600,
      fontSize: '1.2rem'
    },
    paymentCard: {
      border: `1px solid ${BORDER_PRIMARY_COLOR}`,
      borderRadius: '5px',
      height: '75%',
      width: '100%'
    },
    selectedCard: {
      borderRadius: '5px',
      margin: '16px 4px',
      padding: '16px',
      border: `1px solid ${PAYMENTS_BACKGROUND_COLOR}`,
      background: `${PAYMENTS_BACKGROUND_COLOR}45`
    },
    payAmountField: {
      margin: '12px 0'
    },
    payAmount: {
      margin: '12px 0',
      display: 'flex',
      justifyContent: 'space-between'
    },
    divider: {
      margin: '16px 0',
      borderTop: `1px solid ${BORDER_COLOR}`
    },
    payAmountCurrencyField: {
      '& .MuiInputBase-root': {
        height: '3.5rem'
      }
    },
    errorResponseStyle: {
      color: DEFAULT_RED_COLOR,
      borderRadius: '5px',
      padding: '10px',
      textAlign: 'center'
    },
    cardMargin: {
      marginTop: '1rem'
    },
    radioButtons: {
      display: 'flex',
      flexDirection: 'column',
      marginLeft: '-1rem'
    },
    radioLabel: {
      // fontWeight: 'bold',
      color: 'black',
      fontSize: '1.2rem',
      margin: '0.3rem 0',
      display: 'flex',
      justifyContent: 'space-between'
    },
    chargeView: {
      justifyContent: 'space-between',
      color: 'black',
      display: 'flex',
      fontSize: '1.1rem',
      marginTop: '0.3rem',
      marginBottom: '1rem'
    },
    cardContentView: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between'
    },
    changeCard: {
      color: APP_PRIMARY_COLOR,
      backgroundColor: DEFAULT_WHITE_COLOR
    },
    flexDisplay: {
      flex: 1,
      display: 'flex'
    },
    flex: {
      flex: 1
    },
    weekDayField: {
      flex: 1,
      '& > :first-child': {
        opacity: '1 !important'
      }
    },
    formControl: {
      margin: 0,
      padding: 0,
      width: '100%',
      '& .MuiFormControl-root': {
        margin: 0,
        padding: 0,
        border: 0,
        minWidth: 0,
        flexDirection: 'column',
        position: 'relative',
        display: 'flex'
      },
      '& .MuiOutlinedInput-root': {
        width: '100%',
        borderRadius: '4px'
      },
      '& .MuiRadio-root': {
        padding: 0
      }
    },
    radioButtonControl: {
      margin: 0,
      padding: 0,
      '& .MuiRadio-root': {
        padding: 0
      }
    },
    alignItems: {
      alignItems: 'center'
    },
    blackColor: {
      color: DEFAULT_BLACK_COLOR
    },
    payInLabels: {
      paddingLeft: '2.7rem',
      flex: 1
    },
    payInInstallmentsFieldsPadding: {
      flex: 1,
      alignItems: 'center',
      paddingTop: '0.5rem',
      paddingBottom: '0.5rem'
    },
    radioButtonLabel: {
      paddingLeft: '0.5rem'
    },
    paymentOptionsText: {
      paddingTop: '0.5rem',
      paddingBottom: '0.5rem',
      color: 'black'
    },
    root: {
      '&$MuiDialog-root': {},
      '& .MuiSelect-nativeInput': {
        border: 'none',
        height: '2.1rem'
      }
    },
    input: {
      width: '100%',
      borderRadius: '4px'
    },
    paymentPlanStartSectionMargin: {
      marginTop: '1rem'
    },
    backIconView: {
      marginLeft: '-0.5rem',
      paddingBottom: '0.5rem'
    },
    errorSectionMainView: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      color: DEFAULT_BLACK_COLOR
    },
    transactionErrorView: {
      borderRadius: '0.5rem',
      border: `solid 1px ${DEFAULT_RED_COLOR}`,
      marginTop: '1rem',
      marginBottom: '1rem',
      padding: '1rem',
      lineHeight: '2rem'
    },
    button: {
      height: '3.5rem'
    },
    displayFlex: {
      display: 'flex'
    },
    optionMargin: {
      marginTop: '0.5rem'
    },
    amountPaddingBottom: {
      paddingBottom: '0.3rem'
    },
    paymentAmounts: {
      lineHeight: '1.5em'
    },
    divWrap: {
      flex: 1,
      display: 'flex',
      flexWrap: 'wrap'
    },
    radioButtonSection: {
      paddingTop: '0.5rem'
    },
    sectionBorder: {
      border: '1px solid lightgray',
      padding: '0 1rem'
    },
    bold: {
      fontWeight: 'bold'
    },
    paddingSec: {
      paddingTop: '0.5rem'
    },
    secPadding: {
      padding: '0 1rem'
    },
    loader: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      display: 'flex'
    },
    paymentMethods: {
      display: 'flex',
      flexDirection: 'column'
    },
    paymentMethod: {
      display: 'flex',
      flexDirection: 'row'
    }
  })
);

function convertToAmount(amount: string | number): number {
  if (typeof amount === 'string') {
    return +amount.replace(/\$/g, '').replace(/,/g, '');
  } else if (typeof amount === 'number') {
    return amount;
  } else {
    return 0;
  }
}

function toAmount(amount: string | number): number {
  const value = convertToAmount(amount);
  return Math.round(value * 100) / 100;
}
// FIXME: Declare the interface here and also the proper types
const CardPaymentDashboard = (props: any): React.ReactElement => {
  // const stripe: any = useStripe();
  // const elements: any = useElements();

  const classes = useStyles();
  const {
    history,
    match,
    isAdmin,
    isAdhoc,
    paymentCompleted,
    updatePaymentPlan,
    setConfirmationDialog,
    collectCopay
  } = props;
  const {t} = useTranslation();
  const token = match.params?.token;
  const backToDashboardNavigation = React.useCallback((): void => {
    history?.push(`/${NavRoutes.PUBLIC.PAYMENTS_DASHBOARD}/${token}`);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // redux states
  const payAmountRedux = useSelector((state: any) => state.payments.payAmount);
  const payCashAmountRedux = useSelector(
    (state: any) => state.payments.payCashAmount
  );
  const groupId: any = useSelector((state: any) => state.auth.groupId || null);

  const paymentAmountDetails = useSelector(
    (state: any) => state.payments.paymentAmountDetails
  );
  const paymentTypeRedux = useSelector(
    (state: any) => state?.payments?.paymentType
  );
  const patientsRedux = useSelector((state: any) => state.payments.patients);
  const paymentNoteRedux = useSelector(
    (state: any) => state.payments.paymentNote
  );
  const insuranceNameRedux = useSelector(
    (state: any) => state.payments.insuranceName
  );
  const guarantorDetailsRedux = useSelector(
    (state: any) => state.payments.guarantorDetails
  );
  const isLogin = useSelector((state: any) => state.payments.isLogin);
  const clinicDetails = useSelector(
    (state: any) => state.payments.clinicDetails
  );
  const patientCopayIds = useSelector(
    (state: any) => state.payments?.paymentAmountDetails?.patientCopayIds
  );

  const chargeTypesAmount = useSelector(
    (state: any) => state.payments?.paymentAmountDetails?.chargeTypesAmount
  );
  const guarantorPaymentPlanExist = useSelector(
    (state: any) =>
      state.payments?.clinicDetails?.guarantor_details?.payment_plan_status
  );

  const guarantorDetails = useSelector(
    (state: any) => state.payments?.clinicDetails?.guarantor_details
  );

  const baseDetails = useSelector((state: any) => state.payments.baseDetails);
  const code = match.params?.code;
  const dispatch = useDispatch();

  const [breakDownFlag, setBreakDownFlag] = useState(true);
  const [cardMachineErrorMessage, setCardMachineErrorMessage] = useState('');
  const [
    cardMachinePaymentDetails,
    setCardMachinePaymentDetails
  ]: any = useState({});
  const [paymentSectionFlag, setPaymentSectionFlag] = useState(true);

  const [totalChargeAmount, setTotalChargeAmount]: any = useState(0);

  const [totalChargeCashAmount, setTotalChargeCashAmount]: any = useState(0);
  const [selectedPaymentOptionType, setSelectedPaymentOptionType] = useState<{
    payNow: boolean;
    payInInstallments: boolean;
    paymentTypeMethod: string;
    payCash: boolean;
  }>({
    payNow: true,
    payInInstallments: false,
    paymentTypeMethod: paymentMethodTypes.PAY_IN_INSTALLMENTS,
    payCash: false
  });

  const [paymentPlanFrequency, setPaymentPlanFrequency]: any = useState({
    label: 'Monthly',
    value: 'monthly',
    frequency_id: PAYMENT_PLAN_FREQUENCY_IDS.MONTHLY
  });

  const [weekDays, setWeekDays]: any = useState([]);
  const [practiceMachinesList, setPracticeMachinesList]: any = useState(false);

  const [practiceMachinesData, setPracticeMachinesData]: any = useState([]);

  const [groupDetails, setGroupDetails]: any = useState({});

  const [isMachineDataLoading, setIsMachineDataLoading]: any = useState(false);

  const [cardMachineDetails, setCardMachineDetails]: any = useState(false);
  const [errorPage, setErrorPage]: any = useState(false);
  const [cardMachineErrorDialog, setCardMachineErrorDialog]: any = useState(
    false
  );
  const [cardMachineDetailsObject, setCardMachineDetailsObject]: any = useState(
    {}
  );
  const [frequencies, setFrequencies] = useState([]);

  const [paymentPlanWeekDay, setPaymentPlanWeekDay]: any = useState({
    label: '',
    value: '',
    key: ''
  });

  const [paymentPlanStart, setPaymentPlanStart] = useState<boolean>(false);

  const installmentDetails = useSelector(
    (state: any) => state.payments.installmentDetails
  );

  const [disablePayments, setDisablePayments] = useState<boolean>(false);

  const [toggle, updateToggle] = useState<boolean>(true);

  const [paymentAmounts, setPaymentAmounts] = useState([]);

  const [guarantorDueLoader, setGuarantorDueLoader] = useState(true);
  const [guarantorDues, setGuarantorDues] = useState({
    copayList: [],
    statementList: [],
    total_copay_amount: 0,
    statement_due_amount: 0,
    total_due_amount: 0,
    loader: true
  });

  const backNavigation = React.useCallback((): void => {
    if (paymentTypeRedux === PaymentTypes.PUBLIC_AD_HOC_PATIENT_PAYMENT) {
      history.push(`/${NavRoutes.PUBLIC.PAYMENT_PRACTICE}/${code}`);
    } else {
      history?.push(`/${NavRoutes.PUBLIC.PAYMENTS_SECTION}/${token}`);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  // form for capturing amount
  const {
    control,
    errors,
    handleSubmit,
    getValues,
    watch,
    reset,
    setValue,
    setError,
    trigger
  } = useForm<any>({
    defaultValues: {
      payAmount: totalChargeAmount
        ? HelperUtils.formatCurrencyAmount(totalChargeAmount)
        : HelperUtils.formatCurrencyAmount(payAmountRedux),
      payment_plan_frequency: paymentPlanFrequency.value || '',
      user_option: false
    },
    mode: 'all',
    resolver: async function (values) {
      const errorsObj: any = {};
      const minimumInstallmentAmount = Number(
        clinicDetails?.clinic_details?.payment_plans?.min_instalment_amount
      );
      if (selectedPaymentOptionType.payInInstallments) {
        if (!values?.total_instalments) {
          errorsObj.total_instalments = {
            message: t('INSTALLMENTS.ERRORS.TOTAL_NUMBER_OF_PAYMENTS_REQUIRED')
          };
        } else if (values.total_instalments) {
          let frequencyMaxInstallments;
          if (
            paymentPlanFrequency.frequency_id ===
            PAYMENT_PLAN_FREQUENCY_IDS.MONTHLY
          ) {
            frequencyMaxInstallments =
              clinicDetails?.clinic_details?.payment_plans
                ?.total_installments || MAX_INSTALMENTS;
          } else if (
            paymentPlanFrequency.frequency_id ===
            PAYMENT_PLAN_FREQUENCY_IDS.WEEKLY
          ) {
            frequencyMaxInstallments =
              clinicDetails?.clinic_details?.payment_plans
                ?.total_weekly_installments || MAX_INSTALMENTS;
          } else if (
            paymentPlanFrequency.frequency_id ===
            PAYMENT_PLAN_FREQUENCY_IDS.BI_WEEKLY
          ) {
            frequencyMaxInstallments =
              clinicDetails?.clinic_details?.payment_plans
                ?.total_bi_weekly_installments || MAX_INSTALMENTS;
          }

          if (values.total_instalments) {
            const checkNumber = checkIfNaturalNumber(
              values.total_instalments.toString()
            );
            if (!checkNumber) {
              errorsObj.total_instalments = {
                message: t(
                  'INSTALLMENTS.ERRORS.TOTAL_NUMBER_OF_PAYMENTS_ERROR',
                  {
                    installments: frequencyMaxInstallments
                  }
                )
              };
            }
          }
          if (values.total_instalments) {
            const fixDecimals = values.total_instalments.toString().split('.');
            if (fixDecimals && fixDecimals.length > 1) {
              errorsObj.total_instalments = {
                message: t(
                  'INSTALLMENTS.ERRORS.TOTAL_NUMBER_OF_PAYMENTS_ERROR',
                  {
                    installments: frequencyMaxInstallments
                  }
                )
              };
            }
          }

          const noOfPayments = Number(values.total_instalments);

          if (noOfPayments < MIN_INSTALMENTS) {
            errorsObj.total_instalments = {
              message: t(
                'INSTALLMENTS.ERRORS.TOTAL_NUMBER_OF_PAYMENTS_GREATER_THAN_2',
                {
                  installments: MIN_INSTALMENTS
                }
              )
            };
          }

          if (noOfPayments > frequencyMaxInstallments) {
            errorsObj.total_instalments = {
              message: t(
                'INSTALLMENTS.ERRORS.TOTAL_NUMBER_OF_PAYMENTS_LESS_THAN_ERROR',
                {
                  installments: frequencyMaxInstallments || MAX_INSTALMENTS
                }
              )
            };
          } else if (noOfPayments > MAX_INSTALMENTS) {
            errorsObj.total_instalments = {
              message: t(
                'INSTALLMENTS.ERRORS.TOTAL_NUMBER_OF_PAYMENTS_LESS_THAN_2OO',
                {
                  installments: MAX_INSTALMENTS
                }
              )
            };
          }
        }

        if (!values.min_instalment_amount) {
          errorsObj.min_instalment_amount = {
            message: 'INSTALLMENTS.ERRORS.MINIMUM_PAYMENT_AMOUNT_REQUIRED'
          };
        }
        if (
          convertToAmount(values.min_instalment_amount) <
          minimumInstallmentAmount
          // &&
          // Number(amount) < minimumInstallmentAmount
        ) {
          errorsObj.min_instalment_amount = {
            message: 'INSTALLMENTS.ERRORS.MINIMUM_PAYMENT_AMOUNT_REQUIRED'
          };
        } else {
          setError('min_instalment_amount', {});
        }

        if (
          paymentPlanFrequency.frequency_id ===
          PAYMENT_PLAN_FREQUENCY_IDS.MONTHLY
        ) {
          if (!values.instalment_start_date) {
            errorsObj.instalment_start_date = {
              ...errorsObj,
              message: 'INSTALLMENTS.ERRORS.PAYMENT_PLAN_START_DATE'
            };
          } else {
            const instalmentStartDate = moment(values.instalment_start_date);
            if (!instalmentStartDate.isValid()) {
              errorsObj.instalment_start_date = {
                ...errorsObj,
                message: 'INSTALLMENTS.ERRORS.PAYMENT_PLAN_START_DATE'
              };
            } else if (instalmentStartDate.diff(moment().startOf('day')) < 0) {
              errorsObj.instalment_start_date = {
                ...errorsObj,
                message: 'INSTALLMENTS.ERRORS.PAYMENT_PLAN_START_DATE'
              };
            }
          }
        }
      } else if (selectedPaymentOptionType.payNow) {
        if (
          paymentTypeRedux !== PaymentTypes.STATEMENT_PAYMENT &&
          paymentTypeRedux !== PaymentTypes.TOTAL_PAYMENT &&
          paymentTypeRedux !== PaymentTypes.PATIENT_COPAY_PAYMENT
        ) {
          return {values: {payAmount: payAmountRedux}, errors: {}};
        }
        if (paymentTypeRedux == PaymentTypes.TOTAL_PAYMENT) {
          if (!values.payAmount) {
            if (paymentAmountDetails.copayAmount === 0) {
              errorsObj.payAmount = {
                message: 'PAYMENTS_LOGIN.CARD.VALIDATIONS.ENTER_AMOUNT'
              };
            } else {
              errorsObj.payAmount = {
                message: 'PAYMENTS_LOGIN.CARD.VALIDATIONS.MIN_PAY_AMOUNT'
              };
            }
          }
          let formatPayAmount = values.payAmount;
          formatPayAmount = formatPayAmount
            .replace(/\$/g, '')
            .replace(/,/g, '');
          const payAmount = toAmount(formatPayAmount);
          const maxAmount = toAmount(payAmountRedux);
          const minCopay = toAmount(paymentAmountDetails.copayAmount);
          if (payAmount > maxAmount) {
            errorsObj.payAmount = {
              message: 'PAYMENTS_LOGIN.CARD.VALIDATIONS.TOTAL_AMOUNT'
            };
          } else if (payAmount < minCopay) {
            errorsObj.payAmount = {
              message: 'PAYMENTS_LOGIN.CARD.VALIDATIONS.MIN_PAY_AMOUNT'
            };
          }
          return {values, errors: errorsObj};
        }
        if (!values.payAmount) {
          errorsObj.payAmount = {
            message: 'PAYMENTS_LOGIN.CARD.VALIDATIONS.PAY_AMOUNT'
          };
        }
        let formatPayAmount = values.payAmount;
        formatPayAmount = formatPayAmount.replace(/\$/g, '').replace(/,/g, '');
        const payAmount = toAmount(formatPayAmount);
        const maxAmount = toAmount(payAmountRedux);
        if (
          payAmount <= 0 ||
          payAmount > maxAmount
        ) {
          errorsObj.payAmount = {
            message: 'PAYMENTS_LOGIN.CARD.VALIDATIONS.PAY_AMOUNT'
          };
        }
      } else if (selectedPaymentOptionType.payCash) {
        if (
          paymentTypeRedux !== PaymentTypes.STATEMENT_PAYMENT &&
          paymentTypeRedux !== PaymentTypes.TOTAL_PAYMENT &&
          paymentTypeRedux !== PaymentTypes.PATIENT_COPAY_PAYMENT
        ) {
          return {values: {payCashAmount: payCashAmountRedux}, errors: {}};
        }
        if (paymentTypeRedux == PaymentTypes.TOTAL_PAYMENT) {
          if (!values.payCashAmount) {
            if (paymentAmountDetails.copayAmount === 0) {
              errorsObj.payCashAmount = {
                message: 'PAYMENTS_LOGIN.CARD.VALIDATIONS.ENTER_AMOUNT'
              };
            } else {
              errorsObj.payCashAmount = {
                message: 'PAYMENTS_LOGIN.CARD.VALIDATIONS.MIN_PAY_AMOUNT'
              };
            }
          }
          let formatPayCashAmount = values.payCashAmount;
          formatPayCashAmount = formatPayCashAmount
            .replace(/\$/g, '')
            .replace(/,/g, '');
          const payCashAmount = toAmount(formatPayCashAmount);
          const maxCashAmount = toAmount(payCashAmountRedux);
          const minCashCopay = toAmount(paymentAmountDetails.copayAmount);
          if (payCashAmount > maxCashAmount) {
            errorsObj.payCashAmount = {
              message: 'PAYMENTS_LOGIN.CARD.VALIDATIONS.TOTAL_AMOUNT'
            };
          } else if (payCashAmount < minCashCopay) {
            errorsObj.payCashAmount = {
              message: 'PAYMENTS_LOGIN.CARD.VALIDATIONS.MIN_PAY_AMOUNT'
            };
          }
          return {values, errors: errorsObj};
        }
        if (!values.payCashAmount) {
          errorsObj.payCashAmount = {
            message: 'PAYMENTS_LOGIN.CARD.VALIDATIONS.PAY_AMOUNT'
          };
        }
        let formatPayCashAmount = values.payCashAmount;
        formatPayCashAmount = formatPayCashAmount
          .replace(/\$/g, '')
          .replace(/,/g, '');
        const payCashAmount = toAmount(formatPayCashAmount);
        const maxCashAmount = toAmount(payCashAmountRedux);
        if (
          payCashAmount <= 0 ||
          payCashAmount > maxCashAmount
        ) {
          errorsObj.payCashAmount = {
            message: 'PAYMENTS_LOGIN.CARD.VALIDATIONS.PAY_AMOUNT'
          };
        }
      }
      return {values, errors: errorsObj};
    }
  });
  const {enqueueSnackbar} = useSnackbar();

  const setLoaders = () => {
    setDisablePayments(true);

    setTimeout(() => {
      setDisablePayments(false);
    }, 1000);
  };

  useEffect(() => {
    reset({
      payAmount: `${HelperUtils.formatCurrencyAmount(payAmountRedux)}`
    });
    setLoaders();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [payAmountRedux]);
  useEffect(() => {
    reset({
      payCashAmount: `${HelperUtils.formatCurrencyAmount(payCashAmountRedux)}`
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [payCashAmountRedux]);

  const getPaymentAmounts = async (instalment_by: boolean) => {
    try {
      const {clinic_group_id, clinic_id} = clinicDetails;

      if (clinic_group_id && clinic_id) {
        const min_instalment_amount = getValues('min_instalment_amount')
          ? convertToAmount(getValues('min_instalment_amount'))
          : returnAmountOfPayment();
        const payload = {
          due_amount: Number(paymentAmountDetails?.dueAmount || '').toFixed(2),
          number_of_payments: Number(
            getValues('total_instalments') ?? returnNumberOfPayments()
          ),
          amount_of_payment: Number(min_instalment_amount),
          instalment_by: instalment_by ? 'count' : 'amount'
        };
        /**
         * Conditional (in respect to validation error on UI) check on
         *  1. Number of payment is a valid value
         *  2. Amount of payment is a valid value
         */
        if (instalment_by && !payload.number_of_payments) {
          return;
        }
        if (!instalment_by && !payload.amount_of_payment) {
          return;
        }

        let paymentAmountsResponse: any = [];

        if (isAdmin) {
          paymentAmountsResponse = await generatePaymentAmounts(
            clinic_group_id,
            clinic_id,
            payload
          );
        } else {
          paymentAmountsResponse = await generatePaymentPlanAmountGuarantorPortal(
            payload
          );
        }

        if (
          paymentAmountsResponse &&
          paymentAmountsResponse?.data?.length > 0
        ) {
          setPaymentAmounts(paymentAmountsResponse.data);
          const numberOfPayments = paymentAmountsResponse.data.length;
          setValue('total_instalments', numberOfPayments?.toString());
          setValue(
            'min_instalment_amount',
            paymentAmountsResponse.data[0]?.toString()
          );
        } else {
          setPaymentAmounts([]);
          setValue('total_instalments', '0');
          setValue('min_instalment_amount', '0');
        }
      }
    } catch (error: any) {
      enqueueSnackbar(error && error.message, SnackBarConfig('e'));
    } finally {
      setDisablePayments(false);
      trigger();
    }
  };

  const getPaymentPlanFrequenciesAndWeekDays = async () => {
    // CALL THE BELOW APIS ONLY IN ADMIN PORTAL
    if (!isAdmin) return;
    try {
      const weekDaysResponse = await referenceDataService({
        key: 'week_days'
      });

      if (
        weekDaysResponse &&
        weekDaysResponse?.data &&
        weekDaysResponse?.data?.rows
      ) {
        setWeekDays(weekDaysResponse.data.rows);
      }

      const frequenciesResponse: any = await referenceDataService({
        key: 'payment-plan-frequency'
      });

      if (
        frequenciesResponse &&
        frequenciesResponse?.data &&
        frequenciesResponse?.data?.rows
      ) {
        setFrequencies(frequenciesResponse.data.rows);
      }
    } catch (error: any) {
      enqueueSnackbar(error && error?.message, SnackBarConfig('e'));
      throw error;
    }
  };

  useEffect(() => {
    if (Array.isArray(clinicDetails?.clinic_details?.week_days) && !isAdmin) {
      setWeekDays(clinicDetails?.clinic_details?.week_days);
    }
  }, [clinicDetails?.clinic_details?.week_days, isAdmin]);

  useEffect(() => {
    if (
      Array.isArray(clinicDetails?.clinic_details?.payment_plan_frequency) &&
      !isAdmin
    ) {
      setFrequencies(clinicDetails?.clinic_details?.payment_plan_frequency);
    }
  }, [clinicDetails?.clinic_details?.payment_plan_frequency, isAdmin]);

  const getGuarantorDueBalances = async () => {
    try {
      const {clinic_group_id, clinic_id, guarantor_id} = clinicDetails;

      if (clinic_group_id && clinic_id) {
        // fix: while doing adhoc payment, guarantor id is undefined and updated loader to false
        if (guarantor_id) {
          let response;

          if (isAdmin) {
            response = await getGuarantorBalancesFromMultipleLocations(
              clinic_group_id,
              guarantor_id,
              clinic_id
            );
          } else {
            response = await getGuarantorDueBalancesGuarantorPortal(
              guarantor_id
            );
          }

          if (response && response?.data && response?.data) {
            const copayRecords = response?.data?.copay_list || [];
            const duesRecords = response?.data?.dues_list || [];
            setGuarantorDues({
              copayList: copayRecords,
              statementList: duesRecords,
              total_copay_amount: response?.data?.summary?.copay_amount,
              statement_due_amount:
                response?.data?.summary?.statement_current_due_amount,
              total_due_amount: response?.data?.summary?.current_due_amount,
              loader: false
            });
          }
        } else {
          setGuarantorDues({
            ...guarantorDues,
            loader: false
          });
        }
      }
    } catch (error: any) {
      enqueueSnackbar(error && error?.message, SnackBarConfig('e'));
      throw error;
    } finally {
      // NOTE: Timeout is required as the loading and setting data is creating a render in-consistency
      // with timeout, the data is set into variables and then the loader is taken out after a while
      // FIXME: Can be reduced to 500
      setTimeout(() => {
        setGuarantorDueLoader(false);
      }, 1000);
    }
  };

  useEffect(() => {
    if (isAdmin) {
      getPaymentPlanFrequenciesAndWeekDays();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAdmin]);

  useEffect(() => {
    getGuarantorDueBalances();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clinicDetails]);

  useEffect(() => {
    if (isAdmin) {
      getClinicGroupsDetails(groupId).then(res => {
        setGroupDetails(res?.data);
      });
    }

    // eslint-disable-next-line
  }, [groupId]);

  // component states
  const [isLoading, setLoader] = React.useState<boolean>(false);
  const [
    reactLoaderComponent,
    setReactLoaderComponent
  ] = React.useState<boolean>(false);
  const [cardState, setCardState] = React.useState<{
    showCard: boolean;
    cardNumber: string;
    cardExpiry: string;
    cardToken: string;
    cardType: string;
    billAddress: string;
    billPostal: string;
  }>({
    cardExpiry: '',
    cardNumber: '',
    cardToken: '',
    cardType: '',
    billAddress: '',
    billPostal: '',
    showCard: false
  });
  const [errorMessage, setErrorMessage] = React.useState<string>('');
  const payAmount = watch('payAmount');
  const payCashAmount = watch('payCashAmount');

  const gotoThanksScreen = (): void => {
    history?.push(`/${NavRoutes.PUBLIC.THANKS_SCREEN}/${token}`);
  };

  const getDetailsForPayment = (): void => {
    if (baseDetails) {
      const {
        clinicId: clinic_id,
        clinicGroupId: clinic_group_id,
        guarantorId: guarantor_id
      } = baseDetails;
      getDetailsFromAdmin({
        clinic_group_id,
        clinic_id,
        guarantor_id,
        payment_method: paymentTypeRedux
      }).then((res: any) => {
        // FETCHING ALL PAYMENT INFORMATION RELATED TO GUARANTOR.
        if (res.data) {
          // SETTING ALL GUARANTOR INFORMATION IN REDUX STATE.
          dispatch({type: PAYMENT_CLINIC_DETAILS, payload: {data: res.data}});
          if (
            [
              PaymentTypes.STATEMENT_PAYMENT,
              PaymentTypes.TOTAL_PAYMENT
            ].includes(paymentTypeRedux)
          ) {
            // SAVING GUARANTOR TOTAL PAYMENT IN REDUX STATE.'
            props._guarantorPayAmount(
              (res.data?.guarantor_details?.current_due_amount ?? 0) +
                (res?.data?.copay_amount ?? 0) +
                (res.data?.charge_types_amount ?? 0)
            );
            props._guarantorPayCashAmount(
              (res.data?.guarantor_details?.current_due_amount ?? 0) +
                (res?.data?.copay_amount ?? 0) +
                (res.data?.charge_types_amount ?? 0)
            );
            // SAVING AMOUNT AND REQUIRED DATA TO REDUX STATE.
            props._saveAmountsAndRequiredDataForPayment({
              dueAmount: res.data?.guarantor_details?.current_due_amount ?? 0,
              copayAmount: res?.data?.copay_amount ?? 0,
              patientCopayIds: res?.data?.patient_copay_ids ?? [],
              chargeTypesAmount: res.data?.charge_types_amount ?? 0,
              chargeTypesList: res?.data?.charge_types_list ?? [],
              chargeTypeIds: res?.data?.charge_type_ids ?? []
            });
          }
        }
      });
    }
  };

  // here goes all the event hooks
  useEffect(() => {
    if (!isAdmin) {
      if (!isLogin) {
        history?.push(`/${NavRoutes.PUBLIC.PAYMENTS_LOGIN}/pay/${token}`);
      }
    } else {
      // if (!clinicDetails || Object.keys(clinicDetails).length === 0) {
      getDetailsForPayment();
      // }
    }

    if (isAdmin) {
      return () => {
        props._guarantorPayAmount(0);
        props._guarantorPayCashAmount(0);
        props._saveAmountsAndRequiredDataForPayment({});
        dispatch(_updatePaymentType(undefined));
      };
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (
      (!isAdmin || !isAdhoc) &&
      paymentAmountDetails?.dueAmount <= 0 &&
      paymentAmountDetails?.copayAmount <= 0 &&
      paymentAmountDetails?.chargeTypesAmount <= 0
    ) {
      backToDashboardNavigation();
    }
  }, [paymentAmountDetails]); // eslint-disable-line react-hooks/exhaustive-deps

  // handling payment success response
  const handlePaymentSuccess = (res: any): void => {
    if (
      clinicDetails.clinic_details?.payment_provider ===
        PAYMENT_METHODS.INSTAMED &&
      !selectedPaymentOptionType.payCash
    ) {
      if (res.data?.TransactionStatus) {
        if (res.data.TransactionStatus === 'C') {
          if (res.data.IsPartiallyApproved) {
            enqueueSnackbar(res.data.ResponseMessage, {
              ...SnackBarConfig('i')
            });
            props._guarantorPaymentResult({
              ...res.data,
              amount: res.data.PartialApprovalAmount
            });
          } else {
            // replaced payAmount with total charge amount to populate correct value in thanks screen.

            props._guarantorPaymentResult({
              ...res.data,
              amount:
                convertToAmount(totalChargeAmount) +
                  +(
                    (convertToAmount(totalChargeAmount) *
                      clinicDetails.clinic_details?.convenience_fee) /
                    100
                  ).toFixed(2) || 0
            });
          }
          if (typeof paymentCompleted === 'function') {
            paymentCompleted();
          }
        } else {
          setLoader(false);
          setErrorMessage(res.data.AuthorizationText);
        }
      }
    } else if (
      clinicDetails.clinic_details?.payment_provider ===
        PAYMENT_METHODS.OPENEDGE &&
      !selectedPaymentOptionType.payCash
    ) {
      if (
        res.data?.app_payment_status === AppPaymentStatus.PAID ||
        res.data?.app_payment_status === AppPaymentStatus.PARTIALLY_PAID
      ) {
        if (res.data?.app_payment_status === AppPaymentStatus.PARTIALLY_PAID) {
          enqueueSnackbar(
            <Trans
              i18nKey={'OPEN_EDGE.PARTIAL_APPROVAL'}
              values={{amount: res.data.amount}}
            />,
            {
              ...SnackBarConfig('i')
            }
          );
        }
        props._guarantorPaymentResult({
          ...res.data
        });
        if (typeof paymentCompleted === 'function') {
          paymentCompleted();
        }
      } else {
        setLoader(false);
        setCardState({
          ...cardState,
          showCard: false
        });
        setErrorMessage(res.data?.error_text);
        if (res.data?.error_text !== 'Payment transaction failed') {
          enqueueSnackbar(res.data?.error_text, {
            ...SnackBarConfig('e')
          });
        }
      }
    } else if (selectedPaymentOptionType.payCash) {
      if (res.data?.app_payment_status === AppPaymentStatus.PAID) {
        props._guarantorPaymentResult({
          ...res.data
        });
        if (typeof paymentCompleted === 'function') {
          paymentCompleted();
        }
      } else {
        setLoader(false);
        setCardState({
          ...cardState,
          showCard: false
        });
        setErrorMessage(res.data?.error_text);
        if (res.data?.error_text !== 'Payment transaction failed') {
          enqueueSnackbar(res.data?.error_text, {
            ...SnackBarConfig('e')
          });
        }
      }
    }
  };
  const handlePaymentError = (err: any): void => {
    if (
      err.data?.app_payment_status === AppPaymentStatus.PAID ||
      err.data?.app_payment_status === AppPaymentStatus.PARTIALLY_PAID
    ) {
      if (err.data?.app_payment_status === AppPaymentStatus.PARTIALLY_PAID) {
        enqueueSnackbar(
          <Trans
            i18nKey={'OPEN_EDGE.PARTIAL_APPROVAL'}
            values={{amount: err.data.amount}}
          />,
          {
            ...SnackBarConfig('i')
          }
        );
      }
      props._guarantorPaymentResult({
        ...err.data
      });
      if (typeof paymentCompleted === 'function') {
        paymentCompleted();
      }
    }
    if (err.data?.FieldErrors) {
      if (
        Array.isArray(err.data.FieldErrors) &&
        err.data.FieldErrors.length > 0
      ) {
        err.data.FieldErrors.forEach((item: any) => {
          if (item.Message) {
            enqueueSnackbar(item.Message, {
              ...SnackBarConfig('e'),
              autoHideDuration: null
            });
          }
        });
      }
    }
    if (err.data?.error_text) {
      enqueueSnackbar(err.data.error_text, {
        ...SnackBarConfig('e'),
        autoHideDuration: null
      });
    }
    if (err.message) {
      enqueueSnackbar(err && err.message, SnackBarConfig('e'));
    }
  };
  useEffect(() => {
    // calling the open edge payment api if reference active exists and the machine is in active state
    if (
      cardMachinePaymentDetails?.body?.machine_id !== undefined &&
      cardMachinePaymentDetails?.body?.machine_status === 'active' &&
      cardMachinePaymentDetails?.body?.reference_id !== ''
    ) {
      paymentPatientMiscChargeSaleService({
        body: cardMachinePaymentDetails?.body,
        payment_type: clinicDetails.clinic_details?.payment_provider,
        clinic_group_id: cardMachinePaymentDetails?.clinic_group_id,
        clinic_id: cardMachinePaymentDetails?.clinic_id,
        guarantor_id: cardMachinePaymentDetails?.guarantor_id
      })
        .then((res: any) => {
          handlePaymentSuccess(res);
          // setting confirmation dialog for cancel icon to false
          setConfirmationDialog(false);
          setReactLoaderComponent(false);
          // Take to machines list dialog when the api fails
          if (
            res?.data?.app_payment_status === 'failed' &&
            cardMachineDetailsObject?.status === 'active' &&
            isAdmin
          ) {
            setCardMachineDetails(false);
            setPracticeMachinesList(true);
            setLoader(false);
            setReactLoaderComponent(false);
          }
        })
        .catch((err: any) => {
          setLoader(false);
          setReactLoaderComponent(false);

          handlePaymentError(err);
          setCardMachineErrorMessage(err?.message);
          // setting confirmation dialog for cancel icon to false
          setConfirmationDialog(false);
          // showing error dialog only if the active card machine payment fails
          if (cardMachineDetailsObject?.status === 'active' && isAdmin) {
            setErrorPage(true);
            setCardMachineErrorMessage(
              err?.message || t('PAYMENTS_LOGIN.PAY_API_ERROR')
            );
          }
        })
        .finally(() => {
          setLoader(false);
        });
    }
    // eslint-disable-next-line
  }, [cardMachinePaymentDetails]);

  const adminGuarantorPayment = (
    data: any,
    clinic_group_id: string | number,
    clinic_id: string | number,
    guarantor_id: string | number
  ) => {
    // getting reference id only if machine_id exists and machine_status is active
    if (data?.machine_id !== undefined && data?.machine_status === 'active') {
      // selected card machine clinic id
      data.selected_clinic_id = cardMachineDetailsObject?.clinic_id || '';
      getCardMachineReferenceId({
        clinic_group_id,
        clinic_id: cardMachineDetailsObject?.clinic_id,
        terminal_id: cardMachineDetailsObject?.terminal_id
      })
        .then((res: any) => {
          data.reference_id = res?.data?.reference_id;
          props._cardMachineReferenceId({
            cardMachineReferenceId: res?.data?.reference_id
          });

          const machineDetails: any = {
            body: data,
            payment_type: clinicDetails.clinic_details?.payment_provider,
            clinic_group_id,
            clinic_id,
            guarantor_id
          };

          setCardMachinePaymentDetails(machineDetails);
          // setCardMachineReferenceId(res?.data?.reference_id);
        })
        .catch((err: any) => {
          setReactLoaderComponent(false);
          setLoader(false);
          setConfirmationDialog(false);
          // showing error dialog only if the active card machine payment fails
          if (cardMachineDetailsObject?.status === 'active' && isAdmin) {
            setErrorPage(true);
            setCardMachineErrorMessage(
              err?.message || t('PAYMENTS_LOGIN.REFERENCE_API_ERROR')
            );
          }
        });
    } else if (data?.machine_id === undefined) {
      data.reference_id = '';
      data.selected_clinic_id = clinic_id;
      paymentPatientMiscChargeSaleService({
        body: data,
        payment_type: selectedPaymentOptionType.payCash ? CASH_PAYMENT: clinicDetails.clinic_details?.payment_provider,
        clinic_group_id,
        clinic_id,
        guarantor_id
      })
        .then((res: any) => {
          handlePaymentSuccess(res);
          // setting confirmation dialog for cancel icon to false
          setConfirmationDialog(false);
        })
        .catch((err: any) => {
          setLoader(false);
          handlePaymentError(err);
          setCardMachineErrorMessage(err?.message);
          // setting confirmation dialog for cancel icon to false
          setConfirmationDialog(false);
        })
        .finally(() => {
          setLoader(false);
        });
    }
  };

  const adminPatientPayment = (
    data: any,
    clinic_group_id: string | number,
    clinic_id: string | number
  ) => {
    paymentPatientSaleService({
      body: {...data, guarantor: guarantorDetailsRedux, clinic_id},
      payment_type: selectedPaymentOptionType.payCash ? CASH_PAYMENT: clinicDetails.clinic_details?.payment_provider,
      clinic_group_id
    })
      .then((res: any) => {
        handlePaymentSuccess(res);
      })
      .catch((err: any) => {
        setLoader(false);
        handlePaymentError(err);
      });
  };

  const publicAdhocPayment = (
    data: any,
    clinic_group_id: string | number,
    clinic_id: string | number
  ): void => {
    if (data?.machine_id !== undefined && data?.machine_status === 'active') {
      // passing card machine clinic id
      data.selected_clinic_id = cardMachineDetailsObject?.clinic_id || '';

      getCardMachineReferenceId({
        clinic_group_id,
        clinic_id: cardMachineDetailsObject?.clinic_id,
        terminal_id: cardMachineDetailsObject?.terminal_id
      })
        .then((res: any) => {
          data.reference_id = res?.data?.reference_id;
          props._cardMachineReferenceId({
            cardMachineReferenceId: res?.data?.reference_id
          });
          // setting confirmation dialog for cancel icon to false
          setConfirmationDialog(false);
        })
        .catch((err: any) => {
          setReactLoaderComponent(false);
          setLoader(false);
          // setting confirmation dialog for cancel icon to false
          setConfirmationDialog(false);
          // showing error dialog only if the active card machine payment fails
          if (cardMachineDetailsObject?.status === 'active' && isAdmin) {
            setErrorPage(true);
            setCardMachineErrorMessage(
              err?.message || t('PAYMENTS_LOGIN.REFERENCE_API_ERROR')
            );
          }
        });
    }

    publicPaymentPatientSaleService({
      body: {...data, guarantor: guarantorDetailsRedux, clinic_id},
      payment_type: selectedPaymentOptionType.payCash ? CASH_PAYMENT: clinicDetails.clinic_details?.payment_provider,
      clinic_short_token: clinicDetails.clinic_details?.short_code,
      clinic_group_id
    })
      .then((res: any) => {
        handlePaymentSuccess(res);
        setReactLoaderComponent(false);
        // Take to machines list dialog when the api fails
        if (
          res?.data?.app_payment_status === 'failed' &&
          cardMachineDetailsObject?.status === 'active' &&
          isAdmin
        ) {
          setCardMachineDetails(false);
          setPracticeMachinesList(true);
          setLoader(false);
          setReactLoaderComponent(false);
        }
      })
      .catch((err: any) => {
        setLoader(false);
        setReactLoaderComponent(false);
        handlePaymentError(err);
        // showing error dialog only if the active card machine payment fails

        if (cardMachineDetailsObject?.status === 'active' && isAdmin) {
          setErrorPage(true);
          setCardMachineErrorMessage(
            err?.message || t('PAYMENTS_LOGIN.CREATE_PAY_API_ERROR')
          );
        }
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const otherChargeTypesOnPriorityOrder = (): Array<string | number> => {
    if (paymentAmountDetails?.chargeTypesList?.length) {
      let allChareTypes = paymentAmountDetails?.chargeTypesList.filter(
        (item: ChargeTypeServiceMapper) =>
          item?.charge_type !== PaymentTypes.PATIENT_COPAY_PAYMENT
      );
      allChareTypes = sortByPriority(allChareTypes);

      const chargeIdsList: Array<string | number> = [];

      allChareTypes.forEach((charge: ChargeTypeServiceMapper) => {
        chargeIdsList.push(charge.id);
      });
      return chargeIdsList;
    } else {
      return [];
    }
  };

  /**
   * FUNCTION TO CREATE PAYMENT PLAN
   * IS ADMIN:TRUE --> CALLING ADMIN PORTAL API TO CREATE PAYMENT PLAN
   * IS ADMIN:FALSE --> CALLING GUARANTOR PORTAL API TO CREATE PAYMENT PLAN
   */
  const createPaymentPlan = async (): Promise<void> => {
    try {
      setLoader(true);
      const {clinic_group_id, clinic_id, guarantor_id} = clinicDetails;

      const dueAmount = Number(paymentAmountDetails?.dueAmount || '').toFixed(
        2
      );
      const payload = {
        billing_address: {
          address_line_1:
            cardState.billAddress ||
            baseDetails?.guarantorDetails?.address_line_1,
          zip_code: HelperUtils.formatZipCode(
            cardState.billPostal || baseDetails?.guarantorDetails?.zip_code
          )
        },
        temporary_token: cardState.cardToken,
        frequency_id: paymentPlanFrequency.frequency_id,
        tenure: installmentDetails.total_installments,
        instalment_amount: installmentDetails.min_instalment_amount,
        guarantor_id: guarantor_id,
        clinic_id,
        clinic_group_id,
        instalment_start_date: installmentDetails.instalment_start_date,
        due_amount: dueAmount,
        charge_day: paymentPlanWeekDay.value ?? null,
        start_payment_plan_today: paymentPlanStart,
        selected_week_day: paymentPlanWeekDay.key,
        machine_id: cardMachineDetailsObject?.id,
        machine_status: cardMachineDetailsObject?.status,
        zone_off_set: moment().format('Z'),
        instalment_by: toggle ? 'count' : 'amount'
      };

      let response;

      if (isAdmin) {
        response = await createPlanForGuarantor(
          clinic_group_id,
          clinic_id,
          payload
        );
      } else {
        response = await createPlanFromGuarantorPortal(guarantor_id, payload);
      }

      if (response) {
        props._guarantorPaymentResult({
          ...response?.data
        });

        if (typeof response.data?.amount_paid === 'number') {
          dispatch(
            _setPayInInstallmentDetails({
              ...installmentDetails,
              min_instalment_amount: response.data?.amount_paid
            })
          );
        }
        if (response?.data?.status === 'failed') {
          enqueueSnackbar(
            response?.message + response?.data?.message,
            SnackBarConfig('i')
          );
        } else {
          enqueueSnackbar(response?.message, SnackBarConfig('s'));
        }
        if (isAdmin) {
          if (typeof paymentCompleted === 'function') {
            paymentCompleted();
          }
        } else {
          gotoThanksScreen();
        }
      }
    } catch (error: any) {
      enqueueSnackbar(error && error?.message, SnackBarConfig('e'));
      throw error;
    } finally {
      setLoader(false);
    }
  };

  // The submit method to identify and call relevant service for payment sale request
  const paymentSaleRequest = (): void => {
    // setPaymentConfirmDialog(false);
    // const formData = getValues();

    if (selectedPaymentOptionType.payNow || selectedPaymentOptionType.payCash) {
      let formatPayAmount: any = selectedPaymentOptionType.payCash
        ? totalChargeCashAmount
        : totalChargeAmount;

      if (
        paymentTypeRedux !== PaymentTypes.STATEMENT_PAYMENT &&
        paymentTypeRedux !== PaymentTypes.TOTAL_PAYMENT
      ) {
        formatPayAmount = selectedPaymentOptionType.payCash
          ? payCashAmountRedux.toString()
          : payAmountRedux.toString();
      }
      formatPayAmount = formatPayAmount.replace(/\$/g, '').replace(/,/g, '');
      const roundedPayloadAmount = toAmount(formatPayAmount);

      if (!formatPayAmount) {
        enqueueSnackbar(
          t('PAYMENTS_LOGIN.CARD.VALIDATIONS.PAY_AMOUNT'),
          SnackBarConfig('w')
        );
        return;
      }
      // FIXME : Get patients data
      let data: any = null;
      data = {
        card: {
          CardNumber: cardState.cardToken,
          Expiration: cardState.cardExpiry
        },
        amount: roundedPayloadAmount,
        payment_method: paymentTypeRedux
      };

      if (
        clinicDetails.clinic_details?.payment_provider ===
        PAYMENT_METHODS.OPENEDGE
      ) {
        data = {
          billing_address: {
            address_line_1:
              cardState.billAddress ||
              baseDetails?.guarantorDetails?.address_line_1,
            zip_code: HelperUtils.formatZipCode(
              cardState.billPostal || baseDetails?.guarantorDetails?.zip_code
            )
          },
          temporary_token: cardState.cardToken,
          amount: roundedPayloadAmount,
          payment_method: paymentTypeRedux
        };

      } else if (
        clinicDetails.clinic_details?.payment_provider ===
        PAYMENT_METHODS.INSTAMED
      ) {
        data = {
          card: {
            CardNumber: cardState.cardToken,
            Expiration: cardState.cardExpiry
          },
          amount: roundedPayloadAmount,
          payment_method: paymentTypeRedux
        };
      }

      setErrorMessage('');
      setLoader(true);
      if (isAdmin && baseDetails) {
        const {
          // clinicId: clinic_id,
          clinicGroupId: clinic_group_id,
          guarantorId: guarantor_id
        } = baseDetails;
        const clinic_id = clinicDetails?.clinic_details.id;
        data['patients'] = patientsRedux;

        if (
          [
            PaymentTypes.STATEMENT_PAYMENT,
            PaymentTypes.TOTAL_PAYMENT,
            PaymentTypes.AD_HOC_PATIENT_PAYMENT,
            PaymentTypes.PATIENT_COPAY_PAYMENT
          ].includes(paymentTypeRedux)
        ) {
          data.patient_copay_ids = patientCopayIds;
          data.charge_types_amount = chargeTypesAmount;
          data.charge_types_ids = otherChargeTypesOnPriorityOrder();
          data.machine_id = cardMachineDetailsObject?.id;
          data.machine_status = cardMachineDetailsObject?.status;
          if (guarantor_id) {
            adminGuarantorPayment(
              data,
              clinic_group_id,
              clinic_id,
              guarantor_id
            );
          } else {
            adminPatientPayment(data, clinic_group_id, clinic_id);
          }
        } else if (paymentTypeRedux === PaymentTypes.AD_HOC_CLINIC_PAYMENT) {
          data['payment_note'] = paymentNoteRedux ?? '';
          data['insurance_name'] = insuranceNameRedux ?? '';
          adhocPaymentClinicSale({
            body: data,
            payment_type: selectedPaymentOptionType.payCash ? CASH_PAYMENT: clinicDetails.clinic_details?.payment_provider,
            clinic_group_id,
            clinic_id
          })
            .then((res: any) => {
              if (
                clinicDetails.clinic_details?.payment_provider ===
                PAYMENT_METHODS.INSTAMED
              ) {
                if (res.data?.TransactionStatus) {
                  if (res.data.TransactionStatus === 'C') {
                    if (res.data.IsPartiallyApproved) {
                      enqueueSnackbar(res.data.ResponseMessage, {
                        ...SnackBarConfig('i')
                      });
                      props._guarantorPaymentResult({
                        ...res.data,
                        amount: res.data.PartialApprovalAmount
                      });
                    } else {
                      // replaced payAmount with total charge amount to populate correct value in thanks screen.

                      props._guarantorPaymentResult({
                        ...res.data,
                        amount:
                          convertToAmount(totalChargeAmount) +
                            +(
                              (convertToAmount(totalChargeAmount) *
                                clinicDetails.clinic_details?.convenience_fee) /
                              100
                            ).toFixed(2) || 0
                      });
                    }
                    if (typeof paymentCompleted === 'function') {
                      paymentCompleted();
                    }
                  } else {
                    setLoader(false);
                    setErrorMessage(res.data.AuthorizationText);
                  }
                }
              } else if (
                clinicDetails.clinic_details?.payment_provider ===
                PAYMENT_METHODS.OPENEDGE
              ) {
                if (
                  res.data?.app_payment_status === AppPaymentStatus.PAID ||
                  res.data?.app_payment_status ===
                    AppPaymentStatus.PARTIALLY_PAID
                ) {
                  if (
                    res.data?.app_payment_status ===
                    AppPaymentStatus.PARTIALLY_PAID
                  ) {
                    enqueueSnackbar(
                      <Trans
                        i18nKey={'OPEN_EDGE.PARTIAL_APPROVAL'}
                        values={{amount: res.data.amount}}
                      />,
                      {
                        ...SnackBarConfig('i')
                      }
                    );
                  }
                  props._guarantorPaymentResult({
                    ...res.data
                  });
                  if (typeof paymentCompleted === 'function') {
                    paymentCompleted();
                  }
                } else {
                  setLoader(false);
                  setCardState({
                    ...cardState,
                    showCard: false
                  });
                  setErrorMessage(res.data.error_text);
                  enqueueSnackbar(res.data.error_text, {
                    ...SnackBarConfig('e')
                  });
                }
              }
            })
            .catch((err: any) => {
              setLoader(false);
              handlePaymentError(err);
            });
        }
      } else {
        if (paymentTypeRedux === PaymentTypes.PUBLIC_AD_HOC_PATIENT_PAYMENT) {
          const {
            clinicId: clinic_id,
            clinicGroupId: clinic_group_id
          } = baseDetails;
          data['patients'] = patientsRedux;
          data['machine_id'] = cardMachineDetailsObject?.id;
          data['machine_status'] = cardMachineDetailsObject?.status;
          publicAdhocPayment(data, clinic_group_id, clinic_id);
        } else {
          data.patient_copay_ids = patientCopayIds;
          data.charge_types_amount = chargeTypesAmount;
          data.charge_types_ids = otherChargeTypesOnPriorityOrder();
          paymentSaleService({
            token,
            payment_method: clinicDetails.clinic_details?.payment_provider,
            body: data
          })
            .then((res: any) => {
              if (
                clinicDetails.clinic_details?.payment_provider ===
                PAYMENT_METHODS.INSTAMED
              ) {
                if (res.data?.TransactionStatus) {
                  if (res.data.TransactionStatus === 'C') {
                    if (res.data.IsPartiallyApproved) {
                      enqueueSnackbar(res.data.ResponseMessage, {
                        ...SnackBarConfig('i')
                      });
                      props._guarantorPaymentResult({
                        ...res.data,
                        amount: res.data.PartialApprovalAmount
                      });
                    } else {
                      // replaced payAmount with total charge amount to populate correct value in thanks screen.
                      props._guarantorPaymentResult({
                        ...res.data,
                        amount:
                          convertToAmount(totalChargeAmount) +
                            +(
                              (convertToAmount(totalChargeAmount) *
                                clinicDetails.clinic_details?.convenience_fee) /
                              100
                            ).toFixed(2) || 0
                      });
                    }
                    gotoThanksScreen();
                  } else {
                    setLoader(false);
                    setErrorMessage(res.data.AuthorizationText);
                  }
                }
              } else if (
                clinicDetails.clinic_details?.payment_provider ===
                PAYMENT_METHODS.OPENEDGE
              ) {
                if (
                  res.data?.app_payment_status === AppPaymentStatus.PAID ||
                  res.data?.app_payment_status ===
                    AppPaymentStatus.PARTIALLY_PAID
                ) {
                  if (
                    res.data?.app_payment_status ===
                    AppPaymentStatus.PARTIALLY_PAID
                  ) {
                    enqueueSnackbar(
                      <Trans
                        i18nKey={'OPEN_EDGE.PARTIAL_APPROVAL'}
                        values={{amount: res.data.amount}}
                      />,
                      {
                        ...SnackBarConfig('i')
                      }
                    );
                  }
                  props._guarantorPaymentResult({
                    ...res.data
                  });
                  gotoThanksScreen();
                } else {
                  setLoader(false);
                  setCardState({
                    ...cardState,
                    showCard: false
                  });
                  setErrorMessage(res.data.error_text);
                  enqueueSnackbar(res.data.error_text, {
                    ...SnackBarConfig('e')
                  });
                }
              }
            })
            .catch((err: any) => {
              setLoader(false);
              if (
                err.data?.app_payment_status === AppPaymentStatus.PAID ||
                err.data?.app_payment_status === AppPaymentStatus.PARTIALLY_PAID
              ) {
                if (
                  err.data?.app_payment_status ===
                  AppPaymentStatus.PARTIALLY_PAID
                ) {
                  enqueueSnackbar(
                    <Trans
                      i18nKey={'OPEN_EDGE.PARTIAL_APPROVAL'}
                      values={{amount: err.data.amount}}
                    />,
                    {
                      ...SnackBarConfig('i')
                    }
                  );
                }
                props._guarantorPaymentResult({
                  ...err.data
                });
                if (typeof paymentCompleted === 'function') {
                  paymentCompleted();
                }
              }
              if (err.data?.FieldErrors) {
                if (
                  Array.isArray(err.data.FieldErrors) &&
                  err.data.FieldErrors.length > 0
                ) {
                  err.data.FieldErrors.forEach((item: any) => {
                    if (item.Message) {
                      enqueueSnackbar(item.Message, {
                        ...SnackBarConfig('e'),
                        autoHideDuration: null
                      });
                    }
                  });
                }
              }
              if (err.data?.error_text) {
                enqueueSnackbar(err.data.error_text, {
                  ...SnackBarConfig('e'),
                  autoHideDuration: null
                });
              }
              if (err.message) {
                enqueueSnackbar(err && err.message, SnackBarConfig('e'));
              }
            });
        }
      }
    } else if (selectedPaymentOptionType.payInInstallments) {
      createPaymentPlan();
    }
  };
  const calculateNumberOfPayments = (typeId: any) => {
    const requiredAmount = Number(
      paymentAmountDetails?.dueAmount || ''
    ).toFixed(2);

    const minimumInstallmentAmount =
      clinicDetails?.clinic_details?.payment_plans?.min_instalment_amount;

    let maxClinicPayments = 0;

    if (typeId === PAYMENT_PLAN_FREQUENCY_IDS.MONTHLY) {
      maxClinicPayments =
        clinicDetails?.clinic_details?.payment_plans?.total_installments;
    } else if (typeId === PAYMENT_PLAN_FREQUENCY_IDS.WEEKLY) {
      maxClinicPayments =
        clinicDetails?.clinic_details?.payment_plans
          ?.total_weekly_installments || MAX_INSTALMENTS;
    } else if (typeId === PAYMENT_PLAN_FREQUENCY_IDS.BI_WEEKLY) {
      maxClinicPayments =
        clinicDetails?.clinic_details?.payment_plans
          ?.total_bi_weekly_installments || MAX_INSTALMENTS;
    }

    let numberOfPayments = Math.floor(
      Number(requiredAmount) / Number(minimumInstallmentAmount)
    );

    /**
     * CHECKING NUMBER OF PAYMENTS > MAX CLINIC CONFIGURATION PAYMENTS
     * IF YES:NUMBER OF PAYMENTS = MAX CLINIC CONFIGURATION PAYMENTS
     * ELSE : NUMBER OF PAYMENTS = DUE AMOUNT / CLINIC CONFIGURATION MINIMUM AMOUNT
     */

    if (numberOfPayments > Number(maxClinicPayments)) {
      numberOfPayments = maxClinicPayments;
    }
    // setValue('total_instalments', numberOfPayments.toString());

    return numberOfPayments?.toString();
  };

  const calculateAmountForInstallment = (installments?: string | number) => {
    let totalNoOfInstallments: any = Number(installments);

    const requiredAmount = Number(paymentAmountDetails?.dueAmount || '');
    if (!totalNoOfInstallments) {
      totalNoOfInstallments = calculateNumberOfPayments(
        paymentPlanFrequency.frequency_id
      );
    }
    if (Number(totalNoOfInstallments) >= MIN_INSTALMENTS) {
      const amountForInstallment =
        Number(requiredAmount) / Number(totalNoOfInstallments);

      const fixToFloor = HelperUtils.fixTo2DecimalFloor(
        Number(amountForInstallment)
      );
      // setValue('min_instalment_amount', fixToFloor);
      return fixToFloor;
    }
    return '0';
  };

  const openCardDetailsSection = () => {
    if (
      paymentTypeRedux !== PaymentTypes.STATEMENT_PAYMENT &&
      paymentTypeRedux !== PaymentTypes.TOTAL_PAYMENT
    ) {
      setTotalChargeAmount(payAmountRedux);
      setTotalChargeCashAmount(payCashAmountRedux);
    } else {
      setTotalChargeAmount(getValues('payAmount'));
      setTotalChargeCashAmount(getValues('payCashAmount'));
    }

    // SETTING UP PAY IN INSTALLMENT VALUES TO REDUX STATE
    if (selectedPaymentOptionType?.payNow) {
      dispatch(_setPayInInstallmentDetails({}));
    } else if (selectedPaymentOptionType?.payInInstallments) {
      // KEPT COMMENTED CODE FOR FUTURE REFERENCE
      // const frequencyId = getValues('frequency');
      // const totalNumberOfInstallments: any = getValues('total_instalments');
      // const minimumInstallmentAmount: any = convertToAmount(
      //   getValues('min_instalment_amount')
      // );
      // const requiredAmount = Number(
      //   paymentAmountDetails?.dueAmount || ''
      // ).toFixed(2);

      // if (
      //   parseInt(
      //     Number(totalNumberOfInstallments * minimumInstallmentAmount).toFixed(
      //       2
      //     )
      //   ) > parseInt(requiredAmount)
      // ) {
      //   enqueueSnackbar(
      //     t('INSTALLMENTS.ERRORS.REQUIRED_ERROR_AMOUNT'),
      //     SnackBarConfig('e')
      //   );
      //   return;
      // }

      if (
        [
          PAYMENT_PLAN_FREQUENCY_IDS.WEEKLY,
          PAYMENT_PLAN_FREQUENCY_IDS.BI_WEEKLY
        ].includes(paymentPlanFrequency.frequency_id)
      ) {
        if (!paymentPlanWeekDay.key && paymentPlanWeekDay.key !== 0) {
          enqueueSnackbar(
            t('INSTALLMENTS.ERRORS.WEEK_DAY_REQUIRED'),
            SnackBarConfig('e')
          );
          return;
        }
      }

      // GENERATE DATES......
      const paymentPlanDates = getInstalmentDates({
        frequency: paymentPlanFrequency.frequency_id,
        selected_week_day: paymentPlanWeekDay.key,
        number_of_instalments: getValues('total_instalments'),
        instalment_start_date: HelperUtils.formatDisplayDate(
          getValues('instalment_start_date') || null,
          'YYYY-MM-DD'
        ),
        start_payment_plan_today: paymentPlanStart
      });

      const details = {
        instalment_start_date: paymentPlanDates.startDate,

        min_instalment_amount: convertToAmount(
          getValues('min_instalment_amount')
        ),
        total_installments: getValues('total_instalments'),
        pay_in_installments_selected: true,
        next_installment_date: paymentPlanDates.nextDate,
        plan_frequency: paymentPlanFrequency.label,
        payment_plan_start_date: paymentPlanDates.startDate
      };
      dispatch(_setPayInInstallmentDetails(details));
    }
    if (cardState.cardNumber) {
      setCardState({...cardState, showCard: true});
      setBreakDownFlag(true);
      setPaymentSectionFlag(false);
    } else {
      setBreakDownFlag(false);
    }
    if (selectedPaymentOptionType?.payCash) {
      setBreakDownFlag(true);
      setPaymentSectionFlag(false);
      setCardState({
        ...cardState,
        showCard: true
      });
      dispatch(_setPayInInstallmentDetails({}));
    }
  };

  // KEPT COMMENTED CODE FOR FUTURE REFERENCE
  // const openPaymentConfirmation = () => {
  //   const formData = getValues();
  //   let formatPayAmount = formData.payAmount;
  //   if (
  //     paymentTypeRedux !== PaymentTypes.STATEMENT_PAYMENT &&
  //     paymentTypeRedux !== PaymentTypes.TOTAL_PAYMENT
  //   ) {
  //     formatPayAmount = payAmountRedux.toString();
  //   }
  //   formatPayAmount = formatPayAmount.replace(/\$/g, '').replace(/,/g, '');
  //   if (!formatPayAmount) {
  //     enqueueSnackbar(
  //       t('PAYMENTS_LOGIN.CARD.VALIDATIONS.PAY_AMOUNT'),
  //       SnackBarConfig('w')
  //     );
  //     return;
  //   } else if (
  //     paymentAmountDetails === undefined ||
  //     (paymentAmountDetails &&
  //       Object.keys(paymentAmountDetails).length === 0) ||
  //     paymentTypeRedux === PaymentTypes.PATIENT_COPAY_PAYMENT
  //   ) {
  //     paymentSaleRequest();
  //   } else if (
  //     (paymentAmountDetails?.chargeTypesList?.length === 1 &&
  //       paymentAmountDetails.dueAmount === 0) ||
  //     (paymentAmountDetails?.chargeTypesList?.length === 0 &&
  //       paymentAmountDetails.dueAmount > 0)
  //   ) {
  //     paymentSaleRequest();
  //   } else {
  //     setPaymentConfirmDialog(true);
  //   }
  // };
  const renderPaymentProvider = () => {
    if (!clinicDetails.clinic_details?.payment_provider) {
      enqueueSnackbar(
        t('PAYMENT_PROVIDER_NOT_CONFIGURED'),
        SnackBarConfig('w')
      );
      return;
    }

    if (
      clinicDetails.clinic_details?.payment_provider ===
        PAYMENT_METHODS.OPENEDGE &&
      !cardMachineDetails
    ) {
      return (
        <OpenEdge
          cardTokenized={(params: any) => {
            setErrorMessage('');
            setCardState({
              ...cardState,
              billAddress: params.billAddress || '',
              billPostal: params.billPostal || '',
              cardNumber: params.maskedCardNumber,
              cardToken: params.temporaryToken,
              showCard: true,
              cardExpiry: params.expiryDate
            });
            setBreakDownFlag(true);
            setPaymentSectionFlag(false);
          }}
        />
      );
    } else if (
      clinicDetails.clinic_details?.payment_provider ===
      PAYMENT_METHODS.INSTAMED
    ) {
      return (
        <Instamed
          corporateId={
            clinicDetails.clinic_details?.instamedDetails?.corporate_id
          }
          accountId={clinicDetails.clinic_details?.instamedDetails?.account_id}
          cardTokenized={(params: any) => {
            setCardState({
              ...cardState,
              cardNumber: params.maskedCardNumber,
              cardToken: params.temporaryToken,
              showCard: true,
              cardExpiry: params.expiryDate
            });

            setBreakDownFlag(true);
            setPaymentSectionFlag(false);
          }}
        />
      );
    }
    return <div />;
  };

  React.useEffect(() => {
    if (paymentAmountDetails && Object.values(paymentAmountDetails).length) {
      // HANDLE ALL OTHER CHARGE TYPE SECTIONS AND FALLING DOWN TO TOTAL_PAYMENT IF HAVE OTHER PAYMENTS.
      if (paymentAmountDetails?.chargeTypeIds?.length) {
        dispatch(_updatePaymentType(PaymentTypes.TOTAL_PAYMENT));
      } else {
        const payments = GuarantorPortalPaymentTypes.filter(
          item => paymentAmountDetails?.[item.amount_key] > 0
        );
        if (payments.length == 1) {
          dispatch(_updatePaymentType(payments[0].value));
        } else {
          dispatch(_updatePaymentType(PaymentTypes.TOTAL_PAYMENT));
        }
      }
    }

    if (isAdmin) {
      return () => {
        dispatch(_updatePaymentType(undefined));
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentAmountDetails]);

  const updateDialogHeaderBasedPaymentType = (paymentType: string) => {
    if (typeof updatePaymentPlan === 'function') {
      updatePaymentPlan(paymentType);
    }
  };

  const renderPayments = () => {
    if (guarantorDueLoader === true) {
      return <Loader />;
    }
    return (
      <div>
        {/* COPAY AND CHARGE TYPE SECTION BASED ON PRIORITY*/}
        {guarantorDues?.copayList?.length > 0 && (
          <div className={classes.sectionBorder}>
            <div className={classes.balanceSectionHeader}>Copay List</div>
            {guarantorDues.copayList.map((item: any, index: any) => {
              return (
                <DueBalancesCard
                  key={index}
                  type={t('DUE_INVOICES.COPAY')}
                  description={item?.description || ''}
                  balance={item?.balance_amount}
                  location={item?.clinic_detail?.name}
                  addedBy={HelperUtils.commaSeparatedFullName(
                    item?.user?.first_name,
                    item?.user?.last_name
                  )}
                  addedAt={HelperUtils.formatDisplayDate(
                    item?.created_at,
                    'MM/DD/YYYY'
                  )}
                />
              );
            })}

            <div className={classes.chargeView}>
              <span className={classes.bold}>
                {t('DUE_INVOICES.TOTAL_COPAY_BALANCE')}
              </span>
              <strong>
                {HelperUtils.formatCurrencyAmount(
                  guarantorDues.total_copay_amount,
                  true
                )}
              </strong>
            </div>
          </div>
        )}
        {/* STATEMENT BALANCE SECTION*/}

        {guarantorDues?.statementList?.length > 0 && (
          <div
            className={classes.sectionBorder}
            data-test-id="pcl-guarantor-outstandingStatements">
            <div className={classes.balanceSectionHeader}>
              {t('DUE_INVOICES.OUTSTANDING_STATEMENT_BALANCE')}
            </div>
            {guarantorDues.statementList.map((item: any, index: any) => {
              return (
                <DueBalancesCard
                  key={index}
                  type={t('DUE_INVOICES.STATEMENT_BALANCE')}
                  balance={item?.current_due_amount}
                  location={item?.clinic_detail?.name}
                />
              );
            })}

            <div className={classes.chargeView}>
              <span className={classes.bold}>
                {t('DUE_INVOICES.TOTAL_STATEMENT_BALANCE')}
              </span>
              <strong>
                {HelperUtils.formatCurrencyAmount(
                  guarantorDues.statement_due_amount,
                  true
                )}
              </strong>
            </div>
          </div>
        )}
      </div>
    );
  };

  // KEPT COMMENTED CODE FOR FUTURE REFERENCE
  // const calculateAmount = (): number => {
  //   const convenienceFeeIncludedAmount = clinicDetails.clinic_details
  //     ?.convenience_fee
  //     ? convertToAmount(payAmount) +
  //         +(
  //           (convertToAmount(payAmount) *
  //             clinicDetails.clinic_details?.convenience_fee) /
  //           100
  //         ).toFixed(2) || 0
  //     : convertToAmount(payAmount);
  //   if (paymentTypeRedux !== PaymentTypes.AD_HOC_CLINIC_PAYMENT) {
  //     return convenienceFeeIncludedAmount;
  //   } else return convertToAmount(payAmount);
  // };

  const showPracticeMachinesList = () => {
    if (!selectedPaymentOptionType?.payInInstallments) {
      if (paymentAmountDetails?.copayAmount !== 0) {
        // conditions to make payment using card machine when pay now option is checked or to collect copay amount
        if (
          getValues('payAmount')?.replace(/\$/g, '').replace(',', '') >=
            paymentAmountDetails?.copayAmount &&
          getValues('payAmount')?.replace(/\$/g, '').replace(',', '') <=
            payAmountRedux
        ) {
          setPracticeMachinesList(true);
          openCardDetailsSection();
        } else if (
          paymentTypeRedux === PaymentTypes.PATIENT_COPAY_PAYMENT &&
          getValues('payAmount') === undefined &&
          payAmountRedux >= 0
        ) {
          setPracticeMachinesList(true);
          openCardDetailsSection();
        }
      } else if (
        paymentAmountDetails?.copayAmount === 0 &&
        getValues('payAmount')?.replace(/\$/g, '').replace(',', '') > 0 &&
        getValues('payAmount')?.replace(/\$/g, '').replace(',', '') <=
          payAmountRedux
      ) {
        // condition to make payment using card machine when pay now option is checked and when copay is zero
        setPracticeMachinesList(true);
        openCardDetailsSection();
      }
    }
  };

  const renderBreakDownAndCardDetailsSection = (): ReactElement => {
    return (
      <div
        data-test-id="pcl-payments-cardOverView"
        key={'amountBreakDown'}
        className={[classes.selectedCard, classes.cardContentView].join(' ')}>
        <div data-test-id="pcl-payments-enteredCardDetails">
          <Typography className={classes.fieldText}>
            <span>{t('PAYMENTS_LOGIN.CARD.CARD_NUMBER')}</span>
          </Typography>
          <Typography className={classes.fieldValue}>
            <span id={'instamedcardinfocontent'}>
              {HelperUtils.maskCardNumber(cardState.cardNumber)}
            </span>
          </Typography>

          <Typography className={classes.fieldText}>
            <span>{t('PAYMENTS_LOGIN.CARD.EXPIRY_DATE')}</span>
          </Typography>
          <Typography className={classes.fieldValue}>
            <span>{cardState.cardExpiry}</span>
          </Typography>
        </div>
        <div className="change-card-div">
          <Button
            data-test-id="pcl-payments-changeCardButton"
            size={'medium'}
            onClick={() => {
              if (!cardMachineDetails) {
                setErrorMessage('');
                setCardState({
                  ...cardState,
                  showCard: false
                });
                setBreakDownFlag(false);
              }
            }}
            className={classes.changeCard}>
            {!cardState.cardNumber
              ? t('PAYMENTS_LOGIN.CARD.ADD_CARD')
              : t('PAYMENTS_LOGIN.CARD.CHANGE_CARD')}
          </Button>
        </div>
      </div>
    );
  };

  const renderPayNowSection = (): ReactElement => {
    return (
      <>
        <div className={classes.paymentMethods}>
          <div className={classes.paymentMethod}>
            <div
              className={[classes.flexDisplay, classes.alignItems].join(' ')}>
              <Radio
                className={classes.radioButtonControl}
                title={t('INSTALLMENTS.PAY_NOW')}
                data-test-id="pcl-statements-payNowCheck"
                checked={selectedPaymentOptionType.payNow}
                onClick={() => {
                  setSelectedPaymentOptionType({
                    payNow: true,
                    payInInstallments: false,
                    paymentTypeMethod: paymentMethodTypes.PAY_NOW,
                    payCash: false
                  });
                  updateDialogHeaderBasedPaymentType(
                    paymentMethodTypes.PAY_NOW
                  );
                  setPaymentPlanFrequency({
                    label: 'Monthly',
                    value: 'monthly',
                    frequency_id: PAYMENT_PLAN_FREQUENCY_IDS.MONTHLY
                  });
                  setPaymentPlanWeekDay({
                    label: '',
                    value: '',
                    key: ''
                  });
                }}
              />
              <span
                className={[classes.blackColor, classes.radioButtonLabel].join(
                  ' '
                )}>
                {t('INSTALLMENTS.PAY_NOW')}
              </span>
            </div>
            <div className={classes.flex}>
              <FormCurrencyField
                fixedDecimalScale={true}
                decimalScale={2}
                className={classes.formControl}
                id={'payAmount'}
                name={'payAmount'}
                type={'text'}
                defaultValue={
                  totalChargeAmount
                    ? HelperUtils.formatCurrencyAmount(totalChargeAmount)
                    : HelperUtils.formatCurrencyAmount(payAmountRedux)
                }
                placeholder={t('PAYMENTS_LOGIN.CARD.PAY_AMOUNT')}
                control={control}
                required={true}
                disabled={!selectedPaymentOptionType.payNow || isLoading}
                error={
                  (selectedPaymentOptionType.payNow &&
                    errors.payAmount?.message) ||
                  ''
                }
              />
            </div>
          </div>
          {isAdmin && (
            <div className={classes.paymentMethod}>
              <div
                className={[classes.flexDisplay, classes.alignItems].join(' ')}>
                <Radio
                  className={classes.radioButtonControl}
                  title={t('INSTALLMENTS.PAY_USING_CASH')}
                  data-test-id="pcl-statements-payCashCheck"
                  checked={selectedPaymentOptionType.payCash}
                  onClick={() => {
                    setSelectedPaymentOptionType({
                      payNow: false,
                      payInInstallments: false,
                      paymentTypeMethod: paymentMethodTypes.PAY_CASH,
                      payCash: true
                    });
                    updateDialogHeaderBasedPaymentType(
                      paymentMethodTypes.PAY_CASH
                    );
                    setPaymentPlanFrequency({
                      label: 'Monthly',
                      value: 'monthly',
                      frequency_id: PAYMENT_PLAN_FREQUENCY_IDS.MONTHLY
                    });
                    setPaymentPlanWeekDay({
                      label: '',
                      value: '',
                      key: ''
                    });
                  }}
                />
                <span
                  className={[
                    classes.blackColor,
                    classes.radioButtonLabel
                  ].join(' ')}>
                  {t('INSTALLMENTS.PAY_USING_CASH')}
                </span>
              </div>
              <div className={classes.flex}>
                <FormCurrencyField
                  fixedDecimalScale={true}
                  decimalScale={2}
                  className={classes.formControl}
                  id={'payCashAmount'}
                  name={'payCashAmount'}
                  type={'text'}
                  placeholder={t('PAYMENTS_LOGIN.CARD.PAY_AMOUNT')}
                  control={control}
                  required={true}
                  defaultValue={
                    totalChargeCashAmount
                      ? HelperUtils.formatCurrencyAmount(totalChargeCashAmount)
                      : HelperUtils.formatCurrencyAmount(payCashAmountRedux)
                  }
                  disabled={!selectedPaymentOptionType.payCash || isLoading}
                  error={
                    (selectedPaymentOptionType.payCash &&
                      errors.payCashAmount?.message) ||
                    ''
                  }
                />
              </div>
            </div>
          )}
        </div>
        {/* Section to show convenience fee and total to be charged. */}
        {paymentTypeRedux !== PaymentTypes.AD_HOC_CLINIC_PAYMENT &&
          (selectedPaymentOptionType.payNow ||
            selectedPaymentOptionType.payCash) &&
          !!clinicDetails.clinic_details?.convenience_fee && (
            <div>
              <div className={classes.payAmount}>
                <Typography className={classes.fieldTextAmount}>
                  <span>
                    {t('PAYMENTS_LOGIN.CARD.CONVENIENCE_FEE_LINE', {
                      convenienceFee:
                        clinicDetails.clinic_details?.convenience_fee
                    })}
                  </span>
                </Typography>
                <div className={classes.payAmountCurrencyField}>
                  <Typography className={classes.fieldValue}>
                    <CurrencyFormatter
                      value={
                        (
                          (convertToAmount(
                            selectedPaymentOptionType.payCash
                              ? payCashAmount
                              : !payAmount && payAmountRedux ? payAmountRedux : payAmount
                          ) *
                            clinicDetails.clinic_details?.convenience_fee) /
                          100
                        ).toFixed(2) || '0'
                      }
                      displayType={'text'}
                      thousandSeparator={true}
                      prefix={'$'}
                      ignoreRound={true}
                      useSign={true}
                    />
                  </Typography>
                </div>
              </div>
              <div className={classes.payAmount}>
                <Typography className={classes.fieldTextAmount}>
                  <span>{t('PAYMENTS_LOGIN.CARD.TOTAL')}</span>
                </Typography>
                <div className={classes.payAmountCurrencyField}>
                  <Typography className={classes.fieldValue}>
                    <CurrencyFormatter
                      value={
                        convertToAmount(
                          selectedPaymentOptionType.payCash
                            ? payCashAmount
                            : !payAmount && payAmountRedux ? payAmountRedux : payAmount
                        ) +
                          +(
                            (convertToAmount(
                              selectedPaymentOptionType.payCash
                                ? payCashAmount
                                : !payAmount && payAmountRedux ? payAmountRedux : payAmount
                            ) *
                              clinicDetails.clinic_details?.convenience_fee) /
                            100
                          ).toFixed(2) || '0'
                      }
                      displayType={'text'}
                      thousandSeparator={true}
                      prefix={'$'}
                      ignoreRound={true}
                      useSign={true}
                    />
                  </Typography>
                </div>
              </div>
            </div>
          )}
        {/* Section to show convenience fee and total to be charged end. */}
      </>
    );
  };

  const handleOnChange = (event: any, country: any | null, key: any): any => {
    // event.persist();
    // event.target.setAttribute('autocomplete', 'off');
    // setTimeout(() => {
    //   setValue(key, '' + event?.target?.value, {
    //     shouldValidate: true
    //   });
    // }, 10);
  };
  const returnNumberOfPayments = () => {
    if (installmentDetails?.total_installments) {
      return installmentDetails.total_installments;
    } else {
      return calculateNumberOfPayments(paymentPlanFrequency.frequency_id);
    }
  };

  const returnAmountOfPayment = () => {
    if (installmentDetails?.total_installments) {
      return calculateAmountForInstallment(
        installmentDetails.total_installments
      );
    } else {
      const total_installments = getValues('total_instalments');
      if (total_installments) {
        return calculateAmountForInstallment(total_installments);
      }
      return calculateAmountForInstallment();
    }
  };
  const renderPaymentStartDate = () => {
    if (installmentDetails?.instalment_start_date) {
      return installmentDetails.instalment_start_date;
    } else {
      return new Date();
    }
  };

  const renderChargeTodaySectionFlag = (): boolean => {
    const dayNumber = moment().day();

    if (paymentPlanWeekDay.key === dayNumber) {
      return true;
    }
    return false;
  };

  const renderPaymentPlanFrequencyDropDown = (): ReactElement => {
    return (
      <FormControl
        fullWidth={true}
        variant="outlined"
        className={classes.formControl}>
        <Controller
          id="payment_plan_frequency"
          margin={'dense'}
          control={control}
          name={'payment_plan_frequency'}
          error={!!errors.total_instalments?.message}
          render={({value, onChange, onBlur}) => (
            <CustomDropDown
              dropDownList={frequencies}
              placeHolderText={t(
                'PAYMENT_PLANS.PLACEHOLDER.SELECT_PAYMENT_PLAN_FREQUENCY'
              )}
              dropDownHeaderText={t(
                'PAYMENT_PLANS.PLACEHOLDER.PAYMENT_PLAN_FREQUENCY'
              )}
              handleAction={item => {
                setError('total_instalments', {});
                setError('min_instalment_amount', {});
                setDisablePayments(true);

                setPaymentPlanFrequency({
                  ...item,
                  frequency_id: item.id
                });
                const totalPayments = calculateNumberOfPayments(item.id);
                setValue('total_instalments', totalPayments);
                onChange(item.value);
                const amount = returnAmountOfPayment();
                setValue('min_instalment_amount', amount);
                setTimeout(() => {
                  setDisablePayments(false);
                  getPaymentAmounts(toggle);
                }, 1000);
              }}
              className={classes.flex}
              defaultValue={paymentPlanFrequency.label}
            />
          )}
        />
      </FormControl>
    );
  };

  const renderPaymentPlanWeekDaysDropDown = (): ReactElement => {
    return (
      <CustomDropDown
        dropDownList={weekDays}
        placeHolderText={t('PAYMENT_PLANS.PLACEHOLDER.SELECT_WEEK_DAY')}
        dropDownHeaderText={t('PAYMENT_PLANS.PLACEHOLDER.WEEK_DAYS')}
        handleAction={item => {
          setPaymentPlanWeekDay({
            ...item
          });
          const dayNumber = moment().day();
          if (item.key === dayNumber) {
            setPaymentPlanStart(true);
          } else {
            setPaymentPlanStart(false);
          }
        }}
        className={classes.weekDayField}
        defaultValue={paymentPlanWeekDay.label}
      />
    );
  };

  const renderChargeTodaySection = (): ReactElement => {
    return (
      <div
        className={[
          classes.flexDisplay,
          classes.alignItems,
          classes.payInInstallmentsFieldsPadding
        ].join(' ')}>
        <div className={classes.flex}>
          <span className={classes.payInLabels}>
            {t('PAYMENT_PLANS.START_PAYMENT_PLAN_TODAY')}
            {/* Start Payment Plan Today */}
          </span>
        </div>

        <FormControlLabel
          style={{flex: 1}}
          label={''}
          control={
            <Controller
              id={'start_payment_plan_today'}
              render={({value, onChange}) => (
                <Checkbox
                  data-test-id="pcl-statements-startPaymentPlanCheckbox"
                  onChange={(e: any) => {
                    onChange(e.target.checked);
                    setPaymentPlanStart(e.target.checked);
                  }}
                  checked={paymentPlanStart}
                />
              )}
              control={control}
              name={'start_payment_plan_today'}
            />
          }
        />
      </div>
    );
  };

  const renderWeeklyAndBiWeeklyFormSection = (): ReactElement => {
    return (
      <div>
        {/* CHARGE CARD ON SECTION */}
        <div
          data-test-id="pcl-statements-selectWeekday"
          className={[
            classes.flexDisplay,
            classes.alignItems,
            classes.payInInstallmentsFieldsPadding
          ].join(' ')}>
          <div className={classes.flex}>
            <span className={classes.payInLabels}>
              {t('PAYMENT_PLANS.CHARGE_CARD_ON')}
            </span>
          </div>
          {renderPaymentPlanWeekDaysDropDown()}
        </div>

        {renderChargeTodaySectionFlag() && renderChargeTodaySection()}
      </div>
    );
  };

  const updateSelectionTypeAndResetPaymentPlanOptions = (
    updateFlag: boolean
  ) => {
    // RESET FORM ERRORS
    setError('min_instalment_amount', {});
    setError('total_instalments', {});
    // CALCULATE NUMBER OF PAYMENTS AND SETUP
    const total_instalments = returnNumberOfPayments();
    setValue('total_instalments', total_instalments);

    // CALCULATE AMOUNT FOR INSTALLMENTS
    const min_installment_amount = returnAmountOfPayment();
    setValue('min_instalment_amount', min_installment_amount);
    // UPDATE STATE
    updateToggle(updateFlag);
    getPaymentAmounts(updateFlag);
  };

  const renderPaymentPlanOptionSection = (
    title: string,
    check: boolean,
    updateFlag: boolean
  ): ReactElement => {
    return (
      <div className={classes.radioButtonSection}>
        <div className={[classes.alignItems, classes.flex].join(' ')}>
          <RadioComponent
            title={title}
            check={check}
            action={(event: any) => {
              updateSelectionTypeAndResetPaymentPlanOptions(updateFlag);
            }}
            className={classes.radioButtonControl}
          />
          <span
            className={[classes.blackColor, classes.radioButtonLabel].join(
              ' '
            )}>
            {title}
          </span>
        </div>
      </div>
    );
  };

  const renderUserPaymentSelectionOption = (): ReactElement => {
    return (
      <div className={classes.flexDisplay}>
        <div
          data-test-id="pcl-statements-calculationBasis"
          className={[
            classes.flexDisplay,
            classes.alignItems,
            classes.payInInstallmentsFieldsPadding
          ].join(' ')}>
          <div className={classes.flex}>
            <div className={classes.payInLabels}>
              {t('PAYMENT_PLANS.AMOUNT_CALCULATION_BASIS')}
            </div>
          </div>
          <div className={classes.flex}>
            <div>
              {renderPaymentPlanOptionSection(
                t('PAYMENT_PLANS.NUMBER_OF_PAYMENTS'),
                toggle,
                true
              )}
              {renderPaymentPlanOptionSection(
                t('PAYMENT_PLANS.PAYMENT_AMOUNT'),
                !toggle,
                false
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderEachInstallmentAmount = (): ReactElement => {
    let amounts: any = paymentAmounts;
    if (amounts && amounts.length) {
      amounts = groupBy(amounts);
      const instalmentsArr: string[] = [];
      Object.keys(amounts).forEach((key: number | string) => {
        instalmentsArr.push(
          `${amounts[key].length} payment${
            amounts[key].length === 1 ? '' : 's'
          } of ${HelperUtils.formatCurrencyAmount(Number(key))}`
        );
      });
      amounts = instalmentsArr;
    }

    return (
      <div className={classes.paymentAmounts}>{amounts.join(' and ')}</div>
    );
  };

  const renderPayInInstallmentSection = (): ReactElement => {
    return (
      <div className={classes.flex}>
        <div
          className={[
            classes.flexDisplay,
            classes.alignItems,
            classes.paymentPlanStartSectionMargin
          ].join(' ')}>
          <Radio
            className={classes.radioButtonControl}
            data-test-id="pcl-statements-startPaymentPlanCheck"
            title={t('INSTALLMENTS.START_PAYMENT_PLAN')}
            checked={selectedPaymentOptionType.payInInstallments}
            onClick={() => {
              setSelectedPaymentOptionType({
                payNow: false,
                payInInstallments: true,
                paymentTypeMethod: paymentMethodTypes.PAY_IN_INSTALLMENTS,
                payCash: false
              });
              updateDialogHeaderBasedPaymentType(
                paymentMethodTypes.PAY_IN_INSTALLMENTS
              );
              getPaymentAmounts(toggle);
            }}
          />
          <span
            className={[classes.blackColor, classes.radioButtonLabel].join(
              ' '
            )}>
            {t('INSTALLMENTS.START_PAYMENT_PLAN', {
              statement_due_amount: HelperUtils.formatCurrencyAmount(
                guarantorDues.statement_due_amount,
                true
              )
            })}
          </span>
        </div>

        {selectedPaymentOptionType.payInInstallments && (
          <div className={[classes.blackColor].join(' ')}>
            {/* Frequency Section */}
            <div
              className={[
                classes.flexDisplay,
                classes.alignItems,
                classes.payInInstallmentsFieldsPadding
              ].join(' ')}>
              <div className={classes.flex}>
                <span className={classes.payInLabels}>
                  {t('INSTALLMENTS.FREQUENCY')}
                </span>
              </div>
              <div className={classes.flex}>
                {renderPaymentPlanFrequencyDropDown()}
              </div>
            </div>
            {/* Frequency Section End */}

            {/* User Selection Option Start */}
            {renderUserPaymentSelectionOption()}
            {/* User Selection Option End */}

            <div>
              <div
                className={[
                  classes.flexDisplay,
                  classes.alignItems,
                  classes.payInInstallmentsFieldsPadding
                ].join(' ')}>
                <div className={classes.flex}>
                  <span className={classes.payInLabels}>
                    {t('INSTALLMENTS.NUMBER_OF_PAYMENTS')}
                  </span>
                </div>
                <div className={classes.flex}>
                  <FormControl
                    fullWidth={true}
                    variant="outlined"
                    error={!!errors?.total_instalments?.message}
                    className={classes.formControl}>
                    <Controller
                      disabled={!toggle}
                      id="total_instalments"
                      margin={'dense'}
                      control={control}
                      name={'total_instalments'}
                      type={'number'}
                      value={'text'}
                      autoComplete="on"
                      placeholder={t('INSTALLMENTS.NUMBER_OF_PAYMENTS')}
                      defaultValue={returnNumberOfPayments()}
                      error={!!errors?.total_instalments?.message}
                      render={({value, onChange, onBlur}) => (
                        <StyledOutlinedInput
                          data-test-id="pcl-guarantor-numberOfPaymentInput"
                          disabled={!toggle}
                          defaultValue={returnNumberOfPayments()}
                          type={'number'}
                          value={value}
                          onChange={(event: any) => {
                            setError('total_instalments', {});
                            onChange(event.target.value);

                            const installmentValue: any = event.target.value;
                            if (
                              installmentValue &&
                              !errors?.total_instalments?.message
                            ) {
                              debounced(toggle);
                            }
                          }}
                        />
                      )}
                    />

                    {!!errors?.total_instalments?.message && (
                      <FormHelperText>
                        {errors?.total_instalments?.message}
                      </FormHelperText>
                    )}
                  </FormControl>
                </div>
              </div>

              {/* Total Installments End */}

              {/* MINIMUM AMOUNT OF INSTALLMENT SECTION */}
              <div
                className={[
                  classes.flexDisplay,
                  classes.alignItems,
                  classes.payInInstallmentsFieldsPadding
                ].join(' ')}>
                <div className={[classes.flex, classes.displayFlex].join(' ')}>
                  <span className={classes.payInLabels}>
                    {t('INSTALLMENTS.AMOUNT_FOR_PAYMENT')}
                  </span>
                  {disablePayments && (
                    <ButtonLoader colorCode={APP_PRIMARY_COLOR} />
                  )}
                </div>
                <div className={classes.flex}>
                  <FormControl
                    fullWidth={true}
                    variant="outlined"
                    className={classes.formControl}
                    error={!!errors.min_instalment_amount?.message}>
                    <FormCurrencyField
                      fixedDecimalScale={true}
                      decimalScale={2}
                      className={classes.formControl}
                      id={'min_instalment_amount'}
                      name={'min_instalment_amount'}
                      type={'text'}
                      placeholder={t('INSTALLMENTS.AMOUNT_FOR_PAYMENT')}
                      control={control}
                      onChange={(event: any) => {
                        setError('total_instalments', {});
                        const amount = event.target.value;

                        if (amount && !errors?.min_instalment_amount?.message) {
                          debounced(toggle);
                        }
                      }}
                      disabled={toggle}
                      defaultValue={returnAmountOfPayment()}
                      error={
                        errors?.min_instalment_amount?.message
                          ? `${t(
                              errors?.min_instalment_amount?.message
                            )} ${HelperUtils.formatCurrencyAmount(
                              clinicDetails?.clinic_details?.payment_plans
                                ?.min_instalment_amount
                            )}`
                          : ''
                      }
                    />
                  </FormControl>
                </div>
              </div>

              {/* MINIMUM AMOUNT OF INSTALLMENT SECTION END */}

              {/* INSTALLMENT START DATE */}

              {paymentPlanFrequency.frequency_id ===
                PAYMENT_PLAN_FREQUENCY_IDS.MONTHLY && (
                <div
                  className={[
                    classes.flexDisplay,
                    classes.alignItems,
                    classes.payInInstallmentsFieldsPadding
                  ].join(' ')}>
                  <div className={classes.flex}>
                    <span className={classes.payInLabels}>
                      {t('INSTALLMENTS.PAYMENT_PLAN_START_DATE')}
                    </span>
                  </div>
                  <div className={classes.flex}>
                    <FormControl
                      fullWidth={true}
                      variant="outlined"
                      error={errors?.instalment_start_date?.message}
                      className={classes.formControl}>
                      <Controller
                        className={classes.formControl}
                        id="instalment_start_date"
                        error={errors?.instalment_start_date?.message}
                        as={
                          <DateTimePickerWrapper
                            style={{width: '100%'}}
                            value={''}
                            disablePast={true}
                            inputProps={{
                              name: 'instalment_start_date',
                              id: 'instalment_start_date',
                              required: true
                            }}
                            placeholder={t(
                              'INSTALLMENTS.PLACEHOLDERS.PAYMENT_PLAN_START_DATE'
                            )}
                            onChange={value => {
                              handleOnChange(
                                value,
                                null,
                                'instalment_start_date'
                              );
                            }}
                          />
                        }
                        margin={'dense'}
                        control={control}
                        name={'instalment_start_date'}
                        type={'string'}
                        value={'text'}
                        autoComplete="on"
                        placeholder={t(
                          'INSTALLMENTS.PLACEHOLDERS.PAYMENT_PLAN_START_DATE'
                        )}
                        defaultValue={renderPaymentStartDate()}
                      />
                      {errors?.instalment_start_date?.message && (
                        <FormHelperText>
                          {t(errors.instalment_start_date.message)}
                        </FormHelperText>
                      )}
                    </FormControl>
                  </div>
                </div>
              )}
              {/* INSTALLMENT START DATE END */}

              {(paymentPlanFrequency.frequency_id ===
                PAYMENT_PLAN_FREQUENCY_IDS.WEEKLY ||
                paymentPlanFrequency.frequency_id ===
                  PAYMENT_PLAN_FREQUENCY_IDS.BI_WEEKLY) &&
                renderWeeklyAndBiWeeklyFormSection()}

              <div
                className={[
                  classes.flexDisplay,
                  classes.alignItems,
                  classes.payInInstallmentsFieldsPadding
                ].join(' ')}>
                <div className={classes.flex}>
                  <span className={classes.payInLabels}>
                    {t('PAYMENT_PLANS.PAYMENT_AMOUNTS')}
                  </span>
                </div>
                <div className={classes.flex}>
                  {disablePayments ? (
                    <ButtonLoader colorCode={APP_PRIMARY_COLOR} />
                  ) : (
                    <div className={classes.divWrap}>
                      {renderEachInstallmentAmount()}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* PAYMENT PLANS WEEKLY AND BI-WEEKLY */}

            {!!clinicDetails.clinic_details?.convenience_fee && (
              <div
                className={[
                  classes.payInInstallmentsFieldsPadding,
                  classes.payInLabels
                ].join(' ')}>
                <div className={classes.payAmount}>
                  <Typography className={classes.fieldTextAmount}>
                    <span>
                      {t('PAYMENTS_LOGIN.CARD.CONVENIENCE_FEE_LINE', {
                        convenienceFee:
                          clinicDetails.clinic_details?.convenience_fee
                      })}
                    </span>
                  </Typography>
                  <div className={classes.payAmountCurrencyField}>
                    <Typography className={classes.fieldValue}>
                      <CurrencyFormatter
                        value={
                          (
                            (convertToAmount(paymentAmountDetails?.dueAmount) *
                              clinicDetails.clinic_details?.convenience_fee) /
                            100
                          ).toFixed(2) || '0'
                        }
                        displayType={'text'}
                        thousandSeparator={true}
                        prefix={'$'}
                        ignoreRound={true}
                        useSign={true}
                      />
                    </Typography>
                  </div>
                </div>
                <div className={classes.payAmount}>
                  <Typography className={classes.fieldTextAmount}>
                    <span>{t('PAYMENTS_LOGIN.CARD.TOTAL')}</span>
                  </Typography>
                  <div className={classes.payAmountCurrencyField}>
                    <Typography className={classes.fieldValue}>
                      <CurrencyFormatter
                        value={
                          convertToAmount(paymentAmountDetails?.dueAmount) +
                            +(
                              (convertToAmount(
                                paymentAmountDetails?.dueAmount
                              ) *
                                clinicDetails.clinic_details?.convenience_fee) /
                              100
                            ).toFixed(2) || '0'
                        }
                        displayType={'text'}
                        thousandSeparator={true}
                        prefix={'$'}
                        ignoreRound={true}
                        useSign={true}
                      />
                    </Typography>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  };

  /**
   * FUNCTION TO RETURN PAYMENT PLAN SECTION SHOW HIDE FLAG
   * @returns boolean
   */

  const renderPayInPaymentsFlag = (): boolean => {
    // CHECKING FOR ADMIN PORTAL;
    if (isAdmin) {
      if (!guarantorPaymentPlanExist) {
        return true;
      } else {
        return false;
      }
    }
    // CHECKING FOR GUARANTOR PORTAL
    else if (
      clinicDetails.clinic_details.pay_in_installments_guarantor_portal &&
      !guarantorPaymentPlanExist
    ) {
      return true;
    } else {
      return false;
    }
  };

  const debounced = useDebouncedCallback(
    // function
    calculationType => {
      getPaymentAmounts(calculationType);
    },
    // delay in ms
    SEARCH_DEBOUNCE_DELAY
  );

  const renderAmountsAndPaymentSections = (): ReactElement => {
    if (guarantorDues.loader) {
      return (
        <div className={classes.loader}>
          <Loader
            style={{color: APP_PRIMARY_COLOR}}
            color={'secondary'}
            size={32}
          />
        </div>
      );
    }

    return (
      <div>
        <div>
          {collectCopay ? (
            <div />
          ) : (
            <div className={classes.payAmountField}>
              {/* do not show the copay and statement payment details for adhoc payments */}
              {!isAdhoc && renderPayments()}
            </div>
          )}

          <div className={[classes.payAmount, classes.secPadding].join(' ')}>
            <Typography
              className={[classes.fieldTextAmount, classes.paddingSec].join(
                ' '
              )}>
              <span className={classes.bold}>
                {[
                  PaymentTypes.STATEMENT_PAYMENT,
                  PaymentTypes.TOTAL_PAYMENT,
                  PaymentTypes.PATIENT_COPAY_PAYMENT
                ].includes(paymentTypeRedux)
                  ? t('PAYMENTS_LOGIN.CARD.DUE_AMOUNT')
                  : t('PAYMENTS_LOGIN.CARD.PAY_ADHOC_AMOUNT')}
              </span>
            </Typography>
            <div className={classes.payAmountCurrencyField}>
              <Typography
                data-test-id="pcl-payments-chargeValue"
                className={[classes.fieldValue, classes.paddingSec].join(' ')}>
                <CurrencyFormatter
                  value={payAmountRedux || '0'}
                  displayType={'text'}
                  thousandSeparator={true}
                  prefix={'$'}
                  ignoreRound={true}
                  useSign={true}
                />
              </Typography>
            </div>
          </div>
        </div>

        <div className={classes.divider} />
        { (paymentTypeRedux === PaymentTypes.STATEMENT_PAYMENT ||
          paymentTypeRedux === PaymentTypes.TOTAL_PAYMENT || paymentTypeRedux === PaymentTypes.PATIENT_COPAY_PAYMENT) && (
          <div className={classes.payAmountField}>
            <Typography className={classes.fieldTextAmount}>
              <span className={classes.paymentOptionsText}>
                {t('INSTALLMENTS.PAYMENT_OPTIONS')}:
              </span>
            </Typography>
            {renderPayNowSection()}

            {clinicDetails?.clinic_details?.payment_plans?.is_enable &&
              renderPayInPaymentsFlag() &&
              renderPayInInstallmentSection()}
            {guarantorPaymentPlanExist === true ? (
              <Typography
                className={[
                  classes.fieldTextAmount,
                  classes.paymentPlanStartSectionMargin
                ].join(' ')}>
                <span>
                  {t('PAYMENT_PLANS.GUARANTOR_PAYMENT_PLAN_EXIST_CONTENT')}
                </span>
              </Typography>
            ) : (
              guarantorDetails?.exist_in_multiple_locations && (
                <Typography
                  className={[
                    classes.fieldTextAmount,
                    classes.paymentPlanStartSectionMargin
                  ].join(' ')}>
                  <span>
                    {/* GUARANTOR EXIST IN MULTIPLE LOCATIONS
                      -> IS ADMIN PORTAL: SHOW ADMIN PORTAL MESSAGE OF GUARANTOR EXIST ON MULTIPLE LOCATIONS
                      -> IS GUARANTOR PORTAL:
                        --> CHECK: IS PAYMENT PLAN CREATION OPTION IS ENABLE TO GUARANTOR PORTAL
                           --> YES: SHOW GUARANTOR PORTAL MESSAGE OF GUARANTOR EXIST ON MULTIPLE LOCATIONS
                           --> NO: ''
                    */}
                    {isAdmin
                      ? t(
                          'PAYMENT_PLANS.GUARANTOR_EXIST_IN_MULTIPLE_LOCATIONS_ADMIN_PORTAL'
                        )
                      : clinicDetails.clinic_details
                          .pay_in_installments_guarantor_portal
                      ? t(
                          'PAYMENT_PLANS.GUARANTOR_EXIST_IN_MULTIPLE_LOCATIONS_GUARANTOR_PORTAL'
                        )
                      : ''}
                  </span>
                </Typography>
              )
            )}
          </div>
        )}
      </div>
    );
  };

  const renderConfirmButtonText = (): string => {
    if (selectedPaymentOptionType.payInInstallments && !cardMachineDetails) {
      const paymentPlanDate = installmentDetails.instalment_start_date;

      const currentDate = HelperUtils.formatDisplayDate(
        new Date(),
        'YYYY-MM-DD'
      );

      if (paymentPlanDate === currentDate) {
        return t('INSTALLMENTS.CONFIRM_AND_PAY');
      } else {
        return t('INSTALLMENTS.CONFIRM');
      }
    }
    return t('INSTALLMENTS.CONFIRM_AND_PAY');
  };

  const setToInitialState = (enableCardMachine: boolean) => {
    // setting to initial state and not calling getPaymentAmounts(payment plan amounts API) to avoid validation issues
    setCardMachineDetailsObject({});
    setErrorPage(false);
    setPracticeMachinesList(enableCardMachine);
    setCardMachineDetails(false);
    setPaymentPlanStart(paymentPlanStart);
    dispatch(_setPayInInstallmentDetails({}));
    setLoader(true);
    setErrorMessage('');
    setCardState({
      cardExpiry: '',
      cardNumber: '',
      cardToken: '',
      cardType: '',
      billAddress: '',
      billPostal: '',
      showCard: false
    });
    setPaymentSectionFlag(true);
    setBreakDownFlag(true);
    setTimeout(() => {
      setValue('payAmount', totalChargeAmount);
      setValue('payCashAmount', totalChargeCashAmount); // when back button clicks that time we are setting totalcharge amount to payCashAmount
      setLoader(false);
    }, 50);
    setReactLoaderComponent(false);
  };

  const renderErrorSection = (): ReactElement => {
    return (
      <div className={classes.errorSectionMainView}>
        <div>
          <span>{t('PAYMENTS_LOGIN.REASON')}</span>
        </div>

        <div className={classes.transactionErrorView}>
          <div>
            {t('PAYMENTS_LOGIN.CARD_NUMBER')}: {cardState.cardNumber}
          </div>
          <div>
            {t('PAYMENTS_LOGIN.AMOUNT')}: {totalChargeAmount}
          </div>
          <div>
            {t('PAYMENTS_LOGIN.ERROR')}: {errorMessage}
          </div>
        </div>

        <Button
          fullWidth
          variant="contained"
          size={'medium'}
          color="primary"
          className={[classes.loginButton, classes.button].join(' ')}
          onClick={() => setToInitialState(false)}>
          {t('COMMON.BACK')}
        </Button>
      </div>
    );
  };
  const showCardMachineDetails = () => {
    if (cardMachineDetailsObject?.status === 'inactive') {
      setCardMachineErrorDialog(true);
    } else if (
      cardMachineDetailsObject?.status !== 'inactive' &&
      isAdmin &&
      cardMachineDetailsObject?.id !== undefined
    ) {
      setCardMachineErrorDialog(false);
      setValue('payAmount', totalChargeAmount);
      paymentSaleRequest();

      setConfirmationDialog(true);
      setReactLoaderComponent(true);
    }
    setCardMachineDetails(true);
    setPracticeMachinesList(false);
  };

  const setMessagesListScreen = () => {
    setCardMachineErrorDialog(false);
    setErrorPage(false);
    setCardMachineDetailsObject({});
    setCardMachineDetails(false);
    setPracticeMachinesList(true);
  };

  return (
    // showing loader component only for card machine payment
    <div
      className="email-check-wrapper"
      data-test-id="pcl-statements-takePaymentDialog">
      {isLoading &&
        !errorPage &&
        reactLoaderComponent &&
        cardMachineDetailsObject?.status === 'active' && (
          <ReactLoader
            setCardMachineDetails={setCardMachineDetails}
            setPracticeMachinesList={setPracticeMachinesList}
            cardMachineDetailsObject={cardMachineDetailsObject}
            cardMachineDetails={cardMachineDetails}
            setReactLoaderComponent={setReactLoaderComponent}
            setLoader={setLoader}
          />
        )}

      {cardMachineDetailsObject?.status === 'inactive' &&
        !isLoading &&
        cardMachineErrorDialog && (
          // showing error dialog ui when the machine is inactive
          <ErrorPage
            cardMachineDetailsObject={cardMachineDetailsObject}
            changePaymentPlanOptions={() => setMessagesListScreen()}
            cardMachineErrorMessage={cardMachineErrorMessage}
            setLoaderComponent={() => {
              setLoader(true);
              setErrorPage(false);
              paymentSaleRequest();
              return true;
            }}
          />
        )}
      {errorPage &&
        !isLoading &&
        cardMachineDetailsObject?.status === 'active' && (
          // showing error dialog ui when there is an issue in making the payment
          <ErrorPage
            changePaymentPlanOptions={() => setToInitialState(true)}
            cardMachineErrorMessage={cardMachineErrorMessage}
            setLoaderComponent={() => {
              setLoader(true);
              setErrorPage(false);
              paymentSaleRequest();
              return true;
            }}
          />
        )}
      {isAdmin &&
        !errorPage &&
        practiceMachinesList &&
        !cardMachineDetails &&
        !isLoading &&
        !cardMachineErrorDialog && (
          // showing card machines for the admin portal only
          <MachineCardComponent
            amount={
              getValues('payAmount') !== undefined
                ? convertToAmount(getValues('payAmount'))
                : payAmountRedux
            }
            statementBalance={paymentAmountDetails?.dueAmount || null}
            copayBalance={paymentAmountDetails?.copayAmount || null}
            otherChargeBalance={paymentAmountDetails?.chargeTypesAmount || null}
            chargeTypeList={paymentAmountDetails?.chargeTypesList || []}
            totalDue={payAmountRedux || '0'}
            clinicConvenienceFeeFlag={
              clinicDetails.clinic_details?.convenience_fee
            }
            convenienceFee={
              (
                (convertToAmount(totalChargeAmount) *
                  clinicDetails.clinic_details?.convenience_fee) /
                100
              ).toFixed(2) || '0'
            }
            totalChargeFee={
              // calculateAmount()

              convertToAmount(totalChargeAmount) +
                +(
                  (convertToAmount(totalChargeAmount) *
                    clinicDetails.clinic_details?.convenience_fee) /
                  100
                ).toFixed(2) || '0'
            }
            baseDetails={baseDetails}
            practiceMachinesList={practiceMachinesList}
            practiceMachinesData={practiceMachinesData}
            setPracticeMachinesData={setPracticeMachinesData}
            isMachineDataLoading={isMachineDataLoading}
            setIsMachineDataLoading={setIsMachineDataLoading}
            setToInitialState={() => setToInitialState(false)}
            showCardMachineDetails={showCardMachineDetails}
            setCardMachineDetailsObject={setCardMachineDetailsObject}
            cardMachineDetails={cardMachineDetails}
          />
        )}

      {!practiceMachinesList &&
        !reactLoaderComponent &&
        !errorPage &&
        cardMachineDetailsObject?.status !== 'inactive' && (
          // proceed to next step only if cardMachineDetailsObject object is empty or the card machine status is active
          <Card className={['card-payment-section', classes.card].join(' ')}>
            <CardContent className={[classes.cardPadding, 'content'].join(' ')}>
              {/* Added !isAdmin check so that the below back navigation button doesn't appear in admin portal  on top of first dialog */}
              <div className="email-check-content-view">
                {(!isDesktop ||
                  paymentTypeRedux ===
                    PaymentTypes.PUBLIC_AD_HOC_PATIENT_PAYMENT) &&
                  !cardMachineDetails &&
                  !isAdmin && (
                    <Typography
                      className={['details-view', classes.backIconView].join(
                        ' '
                      )}
                      component={'div'}>
                      <BackNavigation navigateTo={backNavigation} />
                    </Typography>
                  )}
                {/* Added isAdmin check so that the below back navigation button appears on top of card details section */}
                {!breakDownFlag &&
                  (isDesktop || isAdmin) &&
                  !cardMachineDetails && (
                    <Typography
                      className={['details-view', classes.backIconView].join(
                        ' '
                      )}
                      component={'div'}>
                      <BackNavigation
                        navigateTo={() => setToInitialState(false)}
                      />
                    </Typography>
                  )}

                {!breakDownFlag &&
                  !cardMachineDetails &&
                  !selectedPaymentOptionType.payCash && (
                    <Typography className="details-view" component={'div'}>
                      {t('INSTALLMENTS.CREDIT_DEBIT_CARD')}
                    </Typography>
                  )}

                {!breakDownFlag &&
                  !cardMachineDetails &&
                  !selectedPaymentOptionType.payCash && (
                    <Typography
                      data-test-id="cd d"
                      className="info-text input-header"
                      component={'div'}>
                      {t('PAYMENTS_LOGIN.CARD.CARD_DETAILS_INPUT_ADMIN_PORTAL')}
                    </Typography>
                  )}

                {cardState.showCard && !selectedPaymentOptionType.payCash && (
                  <Typography
                    data-test-id="pcl-payments-cardDetailsOverView"
                    className="info-text input-header"
                    component={'div'}>
                    {t('PAYMENTS_LOGIN.CARD.INFO')}
                  </Typography>
                )}

                <div className={[classes.cardMargin].join('')}>
                  {!breakDownFlag &&
                    // !cardMachineDetails &&
                    renderPaymentProvider()}

                  {breakDownFlag && (
                    <>
                      {cardState.showCard && [
                        !selectedPaymentOptionType.payCash &&
                          renderBreakDownAndCardDetailsSection(),

                        <div key={'details'}>
                          {selectedPaymentOptionType.payCash && (
                            <Typography
                              className={[
                                'details-view',
                                classes.backIconView
                              ].join(' ')}
                              component={'div'}>
                              <BackNavigation
                                navigateTo={() => setToInitialState(false)}
                              />
                            </Typography>
                          )}
                          {selectedPaymentOptionType.payNow ||
                          selectedPaymentOptionType.payCash ? (
                            <ConfirmationDetails
                              machinepayment={false}
                              amount={
                                selectedPaymentOptionType.payNow
                                  ? getValues('payAmount') !== undefined
                                    ? convertToAmount(getValues('payAmount'))
                                    : payAmountRedux
                                  : getValues('payCashAmount') !== undefined
                                  ? convertToAmount(getValues('payCashAmount'))
                                  : payCashAmountRedux
                              }
                              statementBalance={
                                paymentAmountDetails?.dueAmount || null
                              }
                              copayBalance={
                                paymentAmountDetails?.copayAmount || null
                              }
                              otherChargeBalance={
                                paymentAmountDetails?.chargeTypesAmount || null
                              }
                              chargeTypeList={
                                paymentAmountDetails?.chargeTypesList || []
                              }
                              totalDue={
                                selectedPaymentOptionType.payCash
                                  ? payCashAmountRedux
                                  : payAmountRedux || '0'
                              }
                              clinicConvenienceFeeFlag={
                                clinicDetails.clinic_details?.convenience_fee
                              }
                              convenienceFee={
                                (
                                  (convertToAmount(
                                    selectedPaymentOptionType.payCash
                                      ? totalChargeCashAmount
                                      : totalChargeAmount
                                  ) *
                                    clinicDetails.clinic_details
                                      ?.convenience_fee) /
                                  100
                                ).toFixed(2) || '0'
                              }
                              totalChargeFee={
                                // calculateAmount()

                                convertToAmount(
                                  selectedPaymentOptionType.payCash
                                    ? totalChargeCashAmount
                                    : totalChargeAmount
                                ) +
                                  +(
                                    (convertToAmount(
                                      selectedPaymentOptionType.payCash
                                        ? totalChargeCashAmount
                                        : totalChargeAmount
                                    ) *
                                      clinicDetails.clinic_details
                                        ?.convenience_fee) /
                                    100
                                  ).toFixed(2) || '0'
                              }
                            />
                          ) : (
                            <PayInInstallmentDetails
                              changePaymentPlanOptions={() =>
                                setToInitialState(false)
                              }
                            />
                          )}
                        </div>
                      ]}
                      {paymentSectionFlag &&
                        !cardMachineDetails &&
                        renderAmountsAndPaymentSections()}

                      {errorMessage &&
                        !cardMachineDetails &&
                        renderErrorSection()}
                    </>
                  )}

                  {/*  AMOUNT BREAK DOWN SECTION END  */}
                </div>
              </div>
              {/* {cardState.showCard && breakDownFlag && ( */}

              <div className={classes.paymentDialogButtons}>
                {isAdmin &&
                  breakDownFlag &&
                  paymentSectionFlag &&
                  !cardMachineDetails &&
                  clinicDetails.clinic_details?.payment_provider ===
                    PAYMENT_METHODS.OPENEDGE &&
                  !selectedPaymentOptionType.payInInstallments &&
                  !selectedPaymentOptionType.payCash &&
                  groupDetails?.card_machines &&
                  (paymentTypeRedux === PaymentTypes.STATEMENT_PAYMENT ||
                    paymentTypeRedux === PaymentTypes.TOTAL_PAYMENT ||
                    paymentTypeRedux === PaymentTypes.PATIENT_COPAY_PAYMENT ||
                    paymentTypeRedux ===
                      PaymentTypes.PUBLIC_AD_HOC_PATIENT_PAYMENT) && (
                    <div className="buttonView">
                      <Button
                        fullWidth
                        variant="contained"
                        size={'medium'}
                        className={[classes.swipeCardButton].join(' ')}
                        type={'submit'}
                        disabled={isMachineDataLoading || payAmountRedux <= 0}
                        style={{height: '3.5rem'}}
                        onClick={showPracticeMachinesList}>
                        {isMachineDataLoading ? (
                          <Loader />
                        ) : (
                          t('INSTALLMENTS.SWIPE_CARD')
                        )}
                      </Button>
                    </div>
                  )}

                {breakDownFlag && paymentSectionFlag && !cardMachineDetails && (
                  <div className="buttonView">
                    <Button
                      fullWidth
                      variant="contained"
                      size={'medium'}
                      color="primary"
                      className={[classes.enterCardButton].join(' ')}
                      type={'submit'}
                      disabled={
                        isLoading || !breakDownFlag || payAmountRedux <= 0
                      }
                      style={{height: '3.5rem'}}
                      onClick={handleSubmit(openCardDetailsSection)}>
                      {isLoading ? (
                        <Loader />
                      ) : selectedPaymentOptionType.payCash ? (
                        t('INSTALLMENTS.PAY_USING_CASH')
                      ) : (
                        t('INSTALLMENTS.NEXT_CARD_DETAILS')
                      )}
                    </Button>
                  </div>
                )}
              </div>
              {/*  PAY CONFIRM BUTTON: */}
              {cardState.showCard && (
                <div className="buttonView">
                  <Button
                    fullWidth
                    variant="contained"
                    size={'medium'}
                    color="primary"
                    className={[classes.loginButton].join(' ')}
                    type={'submit'}
                    disabled={
                      cardMachineDetails
                        ? !cardMachineDetails
                        : isLoading || !breakDownFlag
                    }
                    style={{height: '3.5rem'}}
                    onClick={() => {
                      setValue('payAmount', totalChargeAmount);
                      setValue('payCashAmount', totalChargeAmount); // This is For API Payload purpose
                      paymentSaleRequest();
                      // if (
                      //   isAdmin &&
                      //   cardMachineDetailsObject?.id !== undefined &&
                      //   cardMachineDetailsObject?.status === 'active'
                      // ) {
                      //   setConfirmationDialog(true);
                      //   setReactLoaderComponent(true);
                      // }
                    }}>
                    {isLoading ? <Loader /> : renderConfirmButtonText()}
                  </Button>
                </div>
              )}
            </CardContent>
          </Card>
        )}

      {/* KEPT COMMENTED CODE FOR FUTURE REFERENCE*/}
      {/* {paymentConfirmDialog && (
        <PaymentConfirmationDialog
          open={paymentConfirmDialog}
          title={t('CHARGE_TYPES.PAYMENT_CONFIRM')}
          subtitle={t('CHARGE_TYPES.PAYMENT_CONFIRM_SUB_TITLE')}
          close={() => {
            setPaymentConfirmDialog(false);
          }}
          handleConfirm={handleSubmit(paymentSaleRequest)}
          amount={
            getValues('payAmount') !== undefined
              ? convertToAmount(getValues('payAmount'))
              : payAmountRedux
          }
          statementBalance={paymentAmountDetails?.dueAmount || null}
          copayBalance={paymentAmountDetails?.copayAmount || null}
          otherChargeBalance={paymentAmountDetails?.chargeTypesAmount || null}
          chargeTypeList={paymentAmountDetails?.chargeTypesList || []}
        />
      )} */}
    </div>
  );
};

export default connect(
  () => {
    return {};
  },
  {
    _guarantorPaymentResult,
    _guarantorPayAmount,
    _saveAmountsAndRequiredDataForPayment,
    _cardMachineReferenceId,
    _guarantorPayCashAmount
  }
)(CardPaymentDashboard);
